/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    IBuyboxAddToWishlistViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxShopSimilarLookViewProps
} from '@msdyn365-commerce-modules/buybox';
import { IBuyboxCallbacks, IBuyboxData, IBuyboxState, IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';
// import { RatingsSummary } from '@msdyn365-commerce/commerce-entities';
import { Module, Node, Button } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    AttributeValue,
    ProductPrice,
    SimpleProduct,
    ProjectionDomain,
    DiscountLine,
    Cart,
    DeliveryOption
} from '@msdyn365-commerce/retail-proxy';
/* VSI Customization - START - 27/10/20 */
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { IBuyboxProps, IBuyboxResources } from '../definition-extensions/buybox.ext.props.autogenerated';
import { Quantity } from '../utilities/quantity';
import { IBuyboxData as IBuyboxViewData } from './buybox.data';
import getBuyboxAddToCart, { IBuyboxAddToCartViewProps } from './custom-components/get-add-to-cart';
import { getBuyboxFindInStore, IBuyboxFindInStoreViewProps } from './custom-components/get-buybox-find-in-store';
import DobbiesModal from '../../../modules/dobbies-marketing-content-block/components/dobbies-modal';
import { vSIInitiateRestCallAsync } from '../../../dotdigital-extension/BackInStockDataAction.g';
import { getCartFromCustomer } from '@msdyn365-commerce/global-state';
import {
    getActivePricesAsync,
    getDeliveryOptionsAsync,
    getEstimatedAvailabilityAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { CheckboxType, ICheckboxState } from '../../../modules/dobbies-cookie-compliance/dobbies-cookie-compliance';
import { CartLine } from '@msdyn365-commerce/retail-proxy';
import { getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ArrayExtensions, QueryResultSettingsProxy, getFallbackImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { CartModulesStateShareInput } from '../../../actions/cart-state-share';
import { IDobbiesAddedProductToBundle } from '../../../modules/dobbies-product-collection/dobbies-product-collection';
import get from 'lodash/get';
import { Modal, ModalBody } from '@msdyn365-commerce-modules/utilities';
import { PriceComponent } from './custom-components/product-price-component';
import { getCartState } from '@msdyn365-commerce/global-state';
import { cartLineQuantityUpdatedAsync } from '@msdyn365-commerce-modules/cart-utilities';
import { ICartActionResult } from '@msdyn365-commerce/global-state';
import MsDyn365 from '@msdyn365-commerce/core';
import { _getCartItemMaxQuantity } from '../../../modules/dobbies-cart/components/dobbies-cart-line-items';
import { getAllOrgUnitLocationsByArea, GetAllOrgUnitLocationsByAreaInput } from '../../../actions/get-all-store-location-information';
import { IFullOrgUnitAvailability } from '../actions/utilities/full-org-unit-availability';
import { getDelayedDeliveryMsg } from '../utilities/estDeliveryDate';
import {
    DeliveryBoxesType,
    getAddToCartBoxes,
    getEstimatedArrivalBy,
    isLowStock,
    ProductArrivalEstimate
} from '../utilities/del-modes-util';
import RenderBanners from './custom-components/image-banners';
import { _getScreenSize } from '../utilities/display-utils';
import { mapProductInventoryInformation } from '../utilities/inventory/product-inventory-utils';
import { getOrgUnitLocObjSelected, setSelectedStore } from '../utilities/cnc-utils';
import { VsiCustomBadges } from './custom-components/vsi-custom-badges';
import { IProductInventoryInformation } from '../actions/utilities/product-inventory-information';
export interface IDobbiesMiniCartSummaryProduct extends SimpleProduct {
    quantity?: number;
}
/* VSI Customization - END -*/

// const NON_HD_DELIVERY_LINES = ['ClickCol', 'Common MOD'];
let counter: number = 0;
const BuyboxView: React.FC<IBuyboxViewProps & IBuyboxProps<IBuyboxData & IBuyboxViewData>> = props => {
    const {
        ModuleProps,
        ProductInfoContainerProps,
        addToWishlist,
        configure,
        title,
        rating,
        shopSimilarLook,
        context: {
            actionContext: {
                requestContext: { cookies }
            }
        }
    } = props;

    const {
        // data: { ratingsSummary, productAttributes, productPrice, product },
        data: { ratingsSummary, productAttributes, product },
        config: { selectedAttributes },
        quantity,
        callbacks,
        state,
        resources,
        slots: { productDetails, ageRestrictionNotification }
    } = props;

    // const pageUrl = props.context.request.url.requestUrl.href.toString();
    // const imageUrl = props.context.request.apiSettings.baseImageUrl.toString();

    const allAttributes = productAttributes.result;
    const defaultMinimumKeyInPrice = 10;
    const defaultMaximumKeyInPrice = 100;
    const [addToCartTiles, setAddToCartTiles] = useState<(JSX.Element[] | undefined)[]>();
    const [loggedInZipCode, setLoggedinZipCode] = useState('');
    const [isHomeDelTileSelected, setIsHomeDelTileSelected] = useState(false);
    const [isCNCTileSelected, setIsCNCTileSelected] = useState(false);
    const [isHomeDelLowStock, setIsHomeDelLowStock] = useState(false);
    const [isCNCLowStock, setIsCNCLowStock] = useState(false);
    const [showAlternativeInfo, setShowAlternativeInfo] = useState(false);
    const [selectedCNCOrgUnitLoc, setSelectedCNCOrgUnitLoc] = useState<IFullOrgUnitAvailability | undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [addToCartModalOpen, setAddToCartModalOpen] = useState(false);
    /* VSI Customization - START - 27/10/20 */
    const onAddToCartClicked = () => {
        if (isCNCTileSelected && product.result) {
            props.data.cart.result
                ?.addProductToCart({
                    product: product.result,
                    count: state.quantity,
                    location: selectedCNCOrgUnitLoc?.OrgUnitAvailability?.OrgUnitLocation,
                    deliveryMode: 'ClickCol'
                })
                .then(() => {
                    const behavior = props.context.app.config && props.context.app.config.addToCartBehavior;
                    if (behavior === undefined || behavior === 'goToCart' || behavior === 'nothing') {
                    } else if (behavior === 'showModal') {
                        callbacks.updateErrorState({
                            configureErrors: {}
                        });
                        setAddToCartModalOpen(true);
                    }
                });
        }
    };
    const onLocChanged = () => {
        if (product.result?.RecordId) {
            getOrgUnitLocObjSelected(product.result?.RecordId, props.context.actionContext)
                .then(res => {
                    setSelectedCNCOrgUnitLoc(res);
                    setIsCNCTileSelected(true);
                })
                .catch(() => {});
        }
    };
    const findInStore = getBuyboxFindInStore(props, state, callbacks, resources, onAddToCartClicked, onLocChanged);
    const reviewsCount = ratingsSummary && ratingsSummary.result && ratingsSummary.result.reviewsCount;

    const mediaGalleryRef = useRef<HTMLDivElement>(null);

    /* Following hook is used to set attributes value to state */
    const [attributes, setAttributes] = useState<AttributeValue[]>([]);
    const [isVendorShipped, SetIsVendorShipped] = useState(true); // Check if product is vendor ship, hide click & collect option
    const [isAgeRestricted, SetIsAgeRestricted] = useState(false); // Check if product has age restriction
    const [productAddedToCart, SetProductAddedToCart] = useState(false); // Check if product is added to cart or not
    const navigationUrl = Msdyn365.getUrlSync('cart', props.context.actionContext); // Url to goto cart on clicking addtocart notification
    const [isProductAvailable, setIsProductAvailable] = useState<boolean | undefined>(true); // Checks if product is oos, display back in stock form
    const [isValidEmail, setIsValidEmail] = useState(true); // Check whether its valid email or not
    // const [requiredQuantity] = useState(1); // Check required quantity of product for customer
    const [platform, setPlatform] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [privacyPolicyChecked, setPrivacyPolicyChecked] = useState(false);
    const [isCnCProductAvailable, setIsCnCProductAvailable] = useState<boolean | undefined>(false);
    const [showBackInStockModal, setShowBackInStockModal] = useState(false);
    const [showThankyoutext, setShowThankyoutext] = useState(false);
    const [displayClubPlusInfo, setDisplayClubPlusInfo] = useState(false);
    const [discountLines, setDiscountLines] = useState<(DiscountLine[] | undefined)[]>();
    const [, setCustomerAffiliations] = useState<Cart | undefined>(undefined);
    const [activePrices, setActivePrices] = useState<(number | undefined)[]>();

    const appleStoreUrl = props.config.appleStoreUrl ?? 'https://apps.apple.com/us/app/planta-keep-your-plants-alive/id1410126781';
    const googlePlayUrl = props.config.googlePlayUrl ?? 'https://play.google.com/store/apps/details?id=com.stromming.planta';

    const isQuickView = !!props.context.request.query?.isQuickView;

    const [cartProducts, setCartProducts] = useState<IDobbiesMiniCartSummaryProduct[]>([]);
    const [renderProductBundlesModal, setRenderProductBundlesModal] = useState(false);
    const [bundlesSummaryScrollPos, setBundlesSummaryScrollPos] = useState(0);
    const [bundlesModalSummaryScrollPos, setBundlesModalSummaryScrollPos] = useState(0);
    const [allBundleProductsOOS, setAllBundleProductsOOS] = useState(false);
    const [productAvailabilitesForCNC, setProductAvailabilitesForCNC] = useState<IProductInventoryInformation[]>();

    /* VSI Customization - END - 19/9/2023 */
    const equalsCheck = (a: number[], b: number[]) => {
        return a.length === b.length && a.every((v, i) => v === b[i]);
    };
    const isEcomProductAvailable = props.data?.productAvailableQuantity?.result?.some(item => item.IsProductAvailable) ?? false;

    const onlyCNCAvailable =
        productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() === 'yes';

    useEffect(() => {
        if (props.context.request.user.isAuthenticated && props.data.customerInformation.result?.Email) {
            setCustomerEmail(props.data.customerInformation.result.Email);
        }
    }, []);

    useEffect(() => {
        if (props.data.bundleProductsShareState.result?.areAllBundleProductsOOS === true && !allBundleProductsOOS) {
            setAllBundleProductsOOS(true);
        } else if (props.data.bundleProductsShareState.result?.areAllBundleProductsOOS === false && allBundleProductsOOS) {
            setAllBundleProductsOOS(false);
        }
    }, [props.data.bundleProductsShareState.result]);

    useEffect(() => {
        if (isCNCTileSelected) {
            if (findInStore?.clickCNC && !selectedCNCOrgUnitLoc) {
                findInStore.clickCNC();
            }
        }
    }, [isCNCTileSelected]);

    useEffect(() => {
        if (!props.data.clickCollectModalState.result?.isModalOpen && !selectedCNCOrgUnitLoc) {
            setIsCNCTileSelected(false);
        }
    }, [props.data.clickCollectModalState.result?.isModalOpen, selectedCNCOrgUnitLoc]);

    useEffect(() => {
        removeSelectedCncCookie();
    }, []);

    useEffect(() => {
        // User is authenticated and product is available for only CNC
        if (props.context.request.user.isAuthenticated && isCnCProductAvailable && (onlyCNCAvailable || !isEcomProductAvailable)) {
            const customerLocalStore = props.data.customerInformation.result?.Attributes?.find(attr => attr.Name === 'Local Store');

            _getAllStores(props, 31.5070767, 74.4315609, 0, 0).then(allStores => {
                const preferStore = allStores.find(
                    store => store.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName === customerLocalStore?.AttributeValue?.StringValue
                );
                const preferStoreStock =
                    productAvailabilitesForCNC &&
                    productAvailabilitesForCNC?.find(
                        inventory => inventory.InventLocationId === preferStore?.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId
                    );
                if (preferStoreStock && preferStoreStock.IsProductAvailable) {
                    setSelectedStore(
                        preferStore?.OrgUnitLocation?.InventoryLocationId || '',
                        product.result?.RecordId || 0,
                        props.context.actionContext
                    );
                    setSelectedCNCOrgUnitLoc(preferStore);
                    setIsCNCTileSelected(true);
                }
            });
        }
        // Select home delivery tile by default
        else if (isEcomProductAvailable) {
            setIsHomeDelTileSelected(true);
        }
    }, [isCnCProductAvailable, isEcomProductAvailable, productAvailabilitesForCNC]);

    const removeSelectedCncCookie = () => {
        const selectedStoresCookie = props.context.actionContext.requestContext.cookies.get('selected_cnc_stores');
        if (selectedStoresCookie.value) {
            props.context.actionContext.requestContext.cookies.remove('selected_cnc_stores');
        }
    };

    const updateModeOfAddToCart = (isHomeDelSelected: boolean, isCNCSelected: boolean) => {
        setIsHomeDelTileSelected(isHomeDelSelected);
        setSelectedCNCOrgUnitLoc(undefined);
        if (!isCNCSelected) {
            removeSelectedCncCookie();
        }
        if (product.result?.RecordId) {
            getOrgUnitLocObjSelected(product.result?.RecordId, props.context.actionContext)
                .then(res => {
                    setSelectedCNCOrgUnitLoc(res);
                    setIsCNCTileSelected(isCNCSelected);
                })
                .catch(() => {});
        }
    };

    const getVendorName = () => {
        const vendornameAttr =
            props.data.productAttributes.result &&
            props.data.productAttributes.result.find(attribute => {
                const attributeName = attribute.Name && attribute.Name.trim().toLowerCase();
                return attributeName === 'vendorname';
            });
        if (vendornameAttr && vendornameAttr.TextValue) {
            return vendornameAttr.TextValue;
        }
        return undefined;
    };

    const isMaximumQuantityAdded = (): boolean => {
        const cookies = props.context.actionContext.requestContext.cookies;
        const productsAddedInBundles = cookies.get('added_products_bundles')?.value || [];
        const productList = new Array();
        const simpleProducts: SimpleProduct[] = cartProducts.filter(cp => {
            if (Array.isArray(productsAddedInBundles)) {
                const ap = productsAddedInBundles.find(addedp => addedp['productId'] === cp.RecordId);
                return ap ? true : false;
            }
            return false;
        });
        simpleProducts.map(p => {
            let quantity = 1;
            if (Array.isArray(productsAddedInBundles)) {
                const ap = productsAddedInBundles.find(addedp => addedp['productId'] === p.RecordId);
                quantity = ap['quantity'];
                const prodInCart = props.data.cart.result?.cart.CartLines?.find(cl => cl.ProductId === ap['productId']);
                if (prodInCart && prodInCart.Quantity) {
                    if (quantity + prodInCart.Quantity > ap['maxQuantity']) {
                        quantity = -1;
                    }
                }
            }
            productList.push({
                product: p,
                count: quantity,
                enableStockCheck: props.context.app.config.enableStockCheck
            });
        });
        for (const sp of productList) {
            if (sp.count === -1) {
                return true;
            }
        }
        return false;
    };
    const _addAllProductsToCart = async (): Promise<void> => {
        const cookies = props.context.actionContext.requestContext.cookies;
        const productsAddedInBundles = cookies.get('added_products_bundles')?.value || [];
        const productList = new Array();
        const allStores = await _getAllStores(props, 31.5070767, 74.4315609, 0, 0);
        const simpleProducts: SimpleProduct[] = cartProducts.filter(cp => {
            if (Array.isArray(productsAddedInBundles)) {
                const ap = productsAddedInBundles.find(addedp => addedp['productId'] === cp.RecordId);
                return ap ? true : false;
            }
            return false;
        });
        simpleProducts.map(p => {
            let quantity = 1;
            if (Array.isArray(productsAddedInBundles)) {
                const ap = productsAddedInBundles.find(addedp => addedp['productId'] === p.RecordId);
                quantity = ap['quantity'];
                const prodInCart = props.data.cart.result?.cart.CartLines?.find(cl => cl.ProductId === ap['productId']);
                if (prodInCart && prodInCart.Quantity) {
                    if (quantity + prodInCart.Quantity > ap['maxQuantity']) {
                        quantity = -1;
                    }
                }
                const inventoryLocationId = ap['inventoryLocationId'];
                if (inventoryLocationId) {
                    const storeLocation = allStores.find(sl => {
                        return sl.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === inventoryLocationId;
                    });
                    if (storeLocation && storeLocation.OrgUnitAvailability?.OrgUnitLocation) {
                        productList.push({
                            product: p,
                            count: quantity,
                            location: storeLocation.OrgUnitAvailability?.OrgUnitLocation,
                            deliveryMode: 'ClickCol'
                        });
                        // productList.push({
                        //     product: p,
                        //     count: quantity,
                        //     enableStockCheck: props.context.app.config.enableStockCheck,
                        // });
                    }
                } else {
                    productList.push({
                        product: p,
                        count: quantity,
                        enableStockCheck: props.context.app.config.enableStockCheck
                    });
                }
            }

            // productList.push({
            //     product: p,
            //     count: quantity,
            //     enableStockCheck: props.context.app.config.enableStockCheck,
            // });
        });
        for (const sp of productList) {
            if (sp.count === -1) {
                return;
            }
        }
        props.data.cart.result
            ?.addProductsToCart(productList)
            .then(() => {
                MsDyn365.isBrowser && window && window.location.assign('/cart');
                cookies.remove('added_products_bundles');
            })
            .catch(error => {
                console.error('Error', error);
            });
    };
    const updateCartProduct = async () => {
        const productIds: number[] = props.data.cart.result?.cart.CartLines
            ? props.data.cart.result?.cart.CartLines?.map(cartline => cartline.ProductId || -1)
            : [];
        const cookies = props.context.actionContext.requestContext.cookies;
        const addedProducts = cookies.get('added_products_bundles')?.value || [];
        if (Array.isArray(addedProducts)) {
            for (const ap of addedProducts) {
                if (!productIds.includes(ap['productId'])) {
                    productIds.push(ap['productId']);
                }
            }
        }
        const productBundleProducts = cookies.get('productBundle_products');
        const updatedProductIds: number[] = [];
        if (Array.isArray(productIds)) {
            for (const prodId of productIds) {
                if (productBundleProducts && Array.isArray(productBundleProducts.value) && productBundleProducts.value['length'] > 0) {
                    for (const prodBP of productBundleProducts.value) {
                        if (+prodBP.itemId === prodId) {
                            updatedProductIds.push(prodId);
                        }
                    }
                }
            }
        }
        let simpleProductsData = ArrayExtensions.validValues(
            await getByIdsAsync(
                {
                    callerContext: props.context.actionContext,
                    queryResultSettings: QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(props.context.actionContext)
                },
                props.context.actionContext.requestContext.apiSettings.channelId
                    ? props.context.actionContext.requestContext.apiSettings.channelId
                    : -1,
                updatedProductIds,
                null,
                props.context.actionContext.requestContext.apiSettings.catalogId
            )
        );

        let simpleProductsWithQuantities = simpleProductsData.map(sp => {
            const prodWithQuantity: IDobbiesMiniCartSummaryProduct = { ...sp, quantity: 1 };
            const cl = props.data.cart.result?.cart.CartLines?.find(c => c.ProductId === prodWithQuantity.RecordId);
            if (Array.isArray(addedProducts)) {
                for (const ap of addedProducts) {
                    if (prodWithQuantity.RecordId === ap['productId']) {
                        prodWithQuantity.quantity = ap['quantity'];
                        if (cl && prodWithQuantity.quantity && cl.Quantity) {
                            prodWithQuantity.quantity += cl.Quantity;
                        }
                    }
                }
            }
            if (cl && cl.Quantity && prodWithQuantity.quantity && prodWithQuantity.quantity <= cl.Quantity) {
                prodWithQuantity.quantity = cl.Quantity;
            }
            return prodWithQuantity;
        });
        const simpleProdIds = simpleProductsWithQuantities.map(prod => prod.RecordId);
        const cartProductIds = cartProducts.map(cartProd => cartProd.RecordId);

        if (!equalsCheck(simpleProdIds, cartProductIds)) {
            const projectDomain: ProjectionDomain = {
                ChannelId: props.context.request.apiSettings.channelId,
                CatalogId: props.context.request.apiSettings.catalogId
            };
            const pIds = simpleProductsWithQuantities.map(p => p.RecordId);
            await getActivePricesAsync(
                {
                    callerContext: props.context.actionContext,
                    queryResultSettings: {}
                },
                projectDomain,
                pIds,
                new Date(),
                null,
                null,
                true
            )
                .then((activePricesResponse: ProductPrice[]) => {
                    if (activePricesResponse && activePricesResponse.length > 0) {
                        simpleProductsWithQuantities = simpleProductsWithQuantities.map(sp => {
                            const activePrice = activePricesResponse.find(price => price.ProductId === sp.RecordId);
                            if (activePrice) {
                                sp.Price = activePrice.CustomerContextualPrice ?? sp.Price;
                                sp.BasePrice = Math.max(
                                    activePrice.BasePrice || 0,
                                    activePrice.TradeAgreementPrice || 0,
                                    activePrice.AdjustedPrice || 0
                                );
                            }
                            return sp;
                        });
                    }
                })
                .catch(() => {});
            setCartProducts(simpleProductsWithQuantities);
        } else {
            if (simpleProductsWithQuantities) {
                let needsUpdate = false;
                for (const cp of cartProducts) {
                    const ap = simpleProductsWithQuantities.find(p => p.RecordId === cp.RecordId);
                    if (ap?.quantity !== cp.quantity) {
                        needsUpdate = true;
                    }
                }
                if (needsUpdate) {
                    const projectDomain: ProjectionDomain = {
                        ChannelId: props.context.request.apiSettings.channelId,
                        CatalogId: props.context.request.apiSettings.catalogId
                    };
                    const pIds = simpleProductsWithQuantities.map(p => p.RecordId);
                    await getActivePricesAsync(
                        {
                            callerContext: props.context.actionContext,
                            queryResultSettings: {}
                        },
                        projectDomain,
                        pIds,
                        new Date(),
                        null,
                        null,
                        true
                    )
                        .then((activePricesResponse: ProductPrice[]) => {
                            if (activePricesResponse && activePricesResponse.length > 0) {
                                simpleProductsWithQuantities = simpleProductsWithQuantities.map(sp => {
                                    const activePrice = activePricesResponse.find(price => price.ProductId === sp.RecordId);
                                    if (activePrice) {
                                        sp.Price = activePrice.CustomerContextualPrice ?? sp.Price;
                                        sp.BasePrice = Math.max(
                                            activePrice.BasePrice || 0,
                                            activePrice.TradeAgreementPrice || 0,
                                            activePrice.AdjustedPrice || 0
                                        );
                                    }
                                    return sp;
                                });
                            }
                        })
                        .catch(() => {});
                    setCartProducts(simpleProductsWithQuantities);
                }
            }
        }
        props.context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: false });
    };

    const addToCart = getBuyboxAddToCart(
        props,
        state,
        callbacks,
        resources,
        isAgeRestricted,
        defaultMinimumKeyInPrice,
        defaultMaximumKeyInPrice,
        onAddToCartClicked,
        addToCartModalOpen,
        setAddToCartModalOpen,
        isCNCTileSelected,
        isHomeDelTileSelected,
        isCnCProductAvailable,
        findInStore
    );

    const displayClubPlus = () => {
        setDisplayClubPlusInfo(!displayClubPlusInfo);
    };

    // Validates email
    const validateEmail = (email: string) => {
        const regix = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regix.test(String(email).toLowerCase());
    };
    const handleNotifyMeClick = () => {
        setPrivacyPolicyChecked(false);
        setCustomerEmail(props.data.customerInformation.result?.Email ?? '');
        setIsValidEmail(true);
        setShowBackInStockModal(true);
        setShowThankyoutext(false);
    };

    const _renderProductTitle = (): string => {
        // @ts-ignore
        var prodTitle = title?.props?.text;
        const attrEcom = allAttributes && allAttributes.find(s => s.Name === 'EComName');
        if (attrEcom && attrEcom.TextValue !== '' && attrEcom.TextValue !== null) {
            prodTitle = attrEcom?.TextValue;
        } else {
            // @ts-ignore
            prodTitle = title?.props?.text;
        }
        return prodTitle;
    };
    useEffect(() => {
        updateCartProduct();
    }, [props.data.cart.result?.cart.CartLines]);
    useEffect(() => {
        if (props.data.cartSharedState?.result?.isCartUpdated) {
            updateCartProduct();
        }
    }, [props.data.cartSharedState.result?.isCartUpdated]);
    useEffect(() => {
        const cookies = props.context.actionContext.requestContext.cookies;
        cookies.remove('added_products_bundles');
        cookies.remove('pdp_product_quantity_for_bundles');
        setCartProducts([]);
        updateCartProduct();
    }, []);
    // Render Popup title
    const _renderPopupTitle = () => {
        // const { popUpHeading } = props.config;
        return (
            <Node className='popup-header' tag='div'>
                <Node role='button' onClick={() => setShowBackInStockModal(false)} className='newsletter-popup-cross' />

                <Msdyn365.Text className={'popup__heading'} text={'Email me when back in stock'} />
            </Node>
        );
    };

    const getPlatform = () => {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)) {
            if (navigator.userAgent.match(/Android/i)) {
                setPlatform('Android');
            } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                setPlatform('IOS');
            }
        } else {
            setPlatform('Web');
        }
    };

    const getProductPrices = async () => {
        try {
            const priceAffiliations = [
                {
                    AffiliationId: props.context.app.config.AffiliationId,
                    LoyaltyTierId: props.context.app.config.LoyaltyTierId,
                    AffiliationTypeValue: props.context.app.config.AffiliationTypeValue,
                    ReasonCodeLines: [],
                    CustomerId: '',
                    ExtensionProperties: []
                }
            ];

            const productRecIds: any = [];
            productRecIds.push(product.result?.RecordId);
            const projectDomain: ProjectionDomain = {
                ChannelId: props.context.request.apiSettings.channelId,
                CatalogId: props.context.request.apiSettings.catalogId
            };
            const cart = await getCartFromCustomer(props.context.actionContext);
            // const affliations = cart?.AffiliationLines;
            setCustomerAffiliations(cart);

            await getActivePricesAsync(
                { callerContext: props.context.actionContext, queryResultSettings: {} },
                projectDomain,
                productRecIds,
                new Date(),
                null,
                priceAffiliations,
                true
            )
                .then((activePricesResponse: ProductPrice[]) => {
                    // const productPrices = activePricesResponse;
                    const discountLine = activePricesResponse.map(priceResp => priceResp.DiscountLines);
                    const customerContextPrice = activePricesResponse.map(priceResp => priceResp.CustomerContextualPrice);

                    if (discountLine) {
                        setActivePrices(customerContextPrice);
                        setDiscountLines(discountLine);
                    }
                })
                .catch((error: Error) => {
                    props.context.actionContext.trace(error.message);
                    props.context.actionContext.telemetry.exception(error);
                    props.context.actionContext.telemetry.debug(
                        '[get Affiliation based price on search result container ]Error executing action'
                    );
                    throw new Error('[get Affiliation based price on search result container]Error executing action');
                });
        } catch (err) {
            console.error(err, 'ERROR');
        }
    };
    //VSI CUSTOMIZATION -START - Check current loyalty tier id.
    const getTierId = () => {
        if (props.data.loyaltyCard.result?.LoyaltyGroups!?.length > 0) {
            const highestActiveLoyaltyCardTier = props.data.loyaltyCard.result!.LoyaltyGroups![0]?.HighestActiveLoyaltyCardTier;
            const loyaltyCardTiers = props.data.loyaltyCard.result!.LoyaltyGroups![0]?.LoyaltyCardTiers;
            const loyaltyCardTier = loyaltyCardTiers?.find(tier => tier.RecordId === highestActiveLoyaltyCardTier);
            return loyaltyCardTier?.LoyaltyTierRecordId;
        }
        return undefined;
    };
    //VSI CUSTOMIZATION -END
    const checkUserDiscounts =
        discountLines &&
        discountLines.map(val => {
            return val && val.find(x => x.OfferId === props.context.app.config.discountId);
        });

    // const checkUserDiscounts = discountLines && discountLines.find(x => x.OfferId === "D000000002")
    const checkUserLoyalty = getTierId() === props.context.app.config.LoyaltyTierId ? true : undefined;
    // customerAffiliations &&
    // customerAffiliations.AffiliationLines &&
    // customerAffiliations.AffiliationLines.find(x => x.LoyaltyTierId === props.context.app.config.LoyaltyTierId);

    // Render popup footer

    const _renderPopupFooter = () => {
        return <></>;
    };
    // Render popup body to show input fields
    const _renderPopupBody = () => {
        return (
            <div className='newsletter-subscription-div'>
                {showThankyoutext ? (
                    <>
                        <div className='thankyou-note text-center'>
                            <h3>
                                Thank you! <br /> Your request has been received.
                            </h3>
                            <p>
                                We’ll notify you by email as soon as <br /> the item is back in stock.
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div>
                            {props.context.request.user.isAuthenticated ? (
                                <>
                                    <p>We’ll email you when the item becomes available.</p>
                                </>
                            ) : (
                                <p>Please enter your email address and we'll email you when the item becomes available.</p>
                            )}
                        </div>
                        <div className='email-address-input'>
                            <input
                                type='email'
                                onChange={e => onChangeEmail(e)}
                                aria-label='Email address'
                                className='email-address-input-text'
                                placeholder={props.resources.emailAddressPlaceholderText}
                                value={customerEmail}
                                required
                            />
                        </div>
                        {!isValidEmail && <div className='msc-notify-me-text'>Please input valid email</div>}
                        <div>
                            <div className='checkbox-privacy-policy'>
                                <div className='checkbox-privacy-policy-content'>
                                    <input
                                        type='checkbox'
                                        className='privacy-policy-text'
                                        aria-label='Accept Privacy Policy'
                                        aria-checked='false'
                                        onChange={e => onChangePrivacy(e)}
                                        id='privacyPolicyCheckbox'
                                    />
                                    <span className='checkbox-privacy-policy-text'>
                                        <p>
                                            I accept the{' '}
                                            <a
                                                className={'privacy-link-underline'}
                                                href={Msdyn365.getUrlSync('privacyPolicy', props.context.actionContext) || ''}
                                                target='_blank'
                                            >
                                                Privacy Policy
                                            </a>
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='msc-notify-me-container'>
                            <button
                                disabled={!privacyPolicyChecked}
                                type='button'
                                onClick={() => showThankyouNote(props, customerEmail)}
                                className='msc-notify-me'
                            >
                                <div>Send request</div>
                            </button>

                            <button type='button' onClick={() => setShowBackInStockModal(false)} className='msc-btn close-popup msc-btn'>
                                Cancel
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    };

    // Renders thankyou note when email is added for back in stock notification
    const showThankyouNote = async (props: IBuyboxViewProps & IBuyboxProps<IBuyboxData & IBuyboxViewData>, email: string) => {
        const mail = email || props.context.request.user.emailAddress || '';
        if (!validateEmail(mail)) {
            setIsValidEmail(false);
        } else {
            setIsValidEmail(true);

            const itemID = product.result?.ItemId;
            const recID = product.result?.RecordId;

            if (!itemID || !recID) return;
            try {
                await vSIInitiateRestCallAsync(
                    { callerContext: props.context.actionContext },
                    props.context.request.user.customerAccountNumber ?? '',
                    mail,
                    itemID,
                    props.context.app?.config?.popularityBannerCompany ?? 'DGC',
                    '1',
                    false,
                    recID
                );
            } catch (e) {
                console.log(e);
            } finally {
                setShowThankyoutext(true);
            }
        }
    };

    const setCookies = () => {
        const _cookieExpirationInSeconds: number = 5_184_000;
        let newRecentlyViewed: number[] | undefined = [];
        const cookieConfig = { maxAge: _cookieExpirationInSeconds };

        const recentlyViewedProdIdsCookie: any = cookies.get('recently-viewed');
        let recentlyViewedArr = recentlyViewedProdIdsCookie.value;

        if (recentlyViewedArr) {
            if (recentlyViewedArr.includes(props.data.product.result?.RecordId)) {
                recentlyViewedArr = recentlyViewedArr.filter((x: number | undefined) => x !== props.data.product.result?.RecordId);
            }

            if (recentlyViewedArr.length >= 10) {
                recentlyViewedArr = recentlyViewedArr.slice(0, recentlyViewedArr.length - 1);
            }
            newRecentlyViewed = [props.data.product.result?.RecordId, ...recentlyViewedArr];
        } else {
            if (props.data.product.result?.RecordId) {
                newRecentlyViewed = [props.data.product.result?.RecordId];
            }
        }

        cookies.set('recently-viewed', newRecentlyViewed, cookieConfig);
    };

    const isVirtualCartEmpty = (): boolean => {
        const cookies = props.context.actionContext.requestContext.cookies;
        let productsAddedInBundles = cookies.get('added_products_bundles')?.value || [];
        if (Array.isArray(productsAddedInBundles)) {
            return !productsAddedInBundles.length;
        }
        return false;
    };

    const closeProductBundlesModal = () => {
        setRenderProductBundlesModal(false);
    };

    const setProductAvailabilityCookieForBundles = (qAvailable: number) => {
        const cookies = props.context.actionContext.requestContext.cookies;
        cookies.set('pdp_product_quantity_for_bundles', qAvailable);
    };

    useEffect(() => {
        if (attributes && attributes.length < 1 && allAttributes) {
            _getCustomAttribute(allAttributes, selectedAttributes, attributes, setAttributes, SetIsAgeRestricted, SetIsVendorShipped).catch(
                () => {
                    return;
                }
            );
        }
        if ((!productAddedToCart && findInStore && findInStore.isAddedToCart) || (addToCart && addToCart.isAddedToCart)) {
            SetProductAddedToCart(true);
        }

        const isAvailable =
            props.data.productAvailableQuantity.result &&
            props.data.productAvailableQuantity.result.find(availability => {
                return availability.IsProductAvailable === true;
            });
        const qAvailable = props.data.productAvailableQuantity.result?.find(
            info => info.ProductAvailableQuantity.ProductId === product.result?.RecordId && info.ProductAvailableQuantity.AvailableQuantity
        );
        const maxQuantity = _getCartItemMaxQuantity(
            props.context.app.config.maxQuantityForCartLineItem,
            props.context.app.config.enableStockCheck || false,
            qAvailable?.ProductAvailableQuantity.AvailableQuantity ? qAvailable.ProductAvailableQuantity.AvailableQuantity : 0,
            getOrderQuantityLimitsFeatureFlag(),
            product?.result?.Behavior?.MaximumQuantity || 0
        );
        setProductAvailabilityCookieForBundles(maxQuantity ? maxQuantity : 0);
        isAvailable ? setIsProductAvailable(isAvailable.IsProductAvailable) : setIsProductAvailable(false);
    }, [productAddedToCart, findInStore]);

    useEffect(() => {
        const cookieValue = cookies.get<ICheckboxState[]>('cookieConsent').value;

        const analyticsCookies = cookieValue?.find(cookie => cookie.name === CheckboxType.Analytics);
        if (analyticsCookies?.value) {
            setCookies();
        }

        getProductPrices();
        getPlatform();

        mediaGalleryRef.current?.addEventListener('contextmenu', e => {
            e.preventDefault();
        });
    }, []);

    const getOrderQuantityLimitsFeatureFlag = (): boolean => {
        const defaultOrderQuantityLimitsFeatureConfig = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits;
        if (defaultOrderQuantityLimitsFeatureConfig === 'none') {
            return false;
        }

        try {
            const featureStatuses = props.data.featureState.result;
            const isQuantityLimitsFeatureEnabledInHq =
                featureStatuses?.find(
                    featureState => featureState.Name === 'Dynamics.AX.Application.RetailDefaultOrderQuantityLimitsFeature'
                )?.IsEnabled || false;
            if (!isQuantityLimitsFeatureEnabledInHq) {
                return false;
            }
        } catch (error) {
            props.telemetry.warning(error as string);
            props.telemetry.debug('Unable to get feature states');
            return false;
        }

        if (defaultOrderQuantityLimitsFeatureConfig === 'all') {
            return true;
        }
        try {
            const customerInfo = props.data.customerInformation.result;
            return (
                !!customerInfo &&
                ((defaultOrderQuantityLimitsFeatureConfig === 'b2b' && customerInfo.IsB2b) ||
                    (defaultOrderQuantityLimitsFeatureConfig === 'b2c' && !customerInfo.IsB2b))
            );
        } catch (error) {
            props.telemetry.warning(error as string);
            props.telemetry.debug('Unable to get customer info');
            return false;
        }
    };

    // Input for email
    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        const email = event.target.value;
        setCustomerEmail(email);
        // if (!validateEmail(email.toString())) {
        //     setIsValidEmail(false);
        // } else {
        //     setIsValidEmail(true);
        // }
    };
    // Input for quantity
    // const onChangeQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const parseQuantity = parseInt(event.target.value);
    //     const productQty = parseQuantity ? parseQuantity : 1;
    //     setRequiredQuantity(productQty);
    // };

    const onChangePrivacy = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPrivacyPolicyChecked(event.target.checked);
    };

    const renderClubPlusBadges = (): number | string | undefined => {
        var CustomerContextualPrice;
        if (activePrices) {
            CustomerContextualPrice = activePrices && activePrices[0] && activePrices[0];
        }
        return CustomerContextualPrice?.toFixed(2);
    };
    const bundleProducts =
        (props.slots.bundledProductsSlot &&
            props.slots.bundledProductsSlot[0] &&
            get(props.slots.bundledProductsSlot[0], 'props.config.productCollection.products')) ||
        [];
    const bundleHasProducts = bundleProducts && bundleProducts.length ? true : false;
    const bundleProductsModal =
        (props.slots.bundledProductsModalSlot &&
            props.slots.bundledProductsModalSlot[0] &&
            get(props.slots.bundledProductsModalSlot[0], 'props.config.productCollection.products')) ||
        [];
    const bundleModalHasProducts = bundleProductsModal && bundleProductsModal.length ? true : false;
    //Customization where stock check for the click and collect
    const isCncAvailable = async () => {
        // const pickupStores = await searchOrgUnitLocationsAsync(
        //     { callerContext: props.context.actionContext, bypassCache: 'none' },
        //     {
        //         DeliveryModeTypeFilterValue: 2
        //     }
        // );
        // const pickupIds = pickupStores.map(store => store.ChannelId);
        // setCnCPickupIds(pickupIds);
        setIsLoading(true);
        const productId: number = props.data.product.result?.RecordId!;
        const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: props.context.actionContext, queryResultSettings: {} }, [
            productId
        ]);

        const productAvailabilitesNonPlantsCNC = await getEstimatedAvailabilityAsync(
            { callerContext: props.context.actionContext },
            { ProductIds: [productId], DefaultWarehouseOnly: false, FilterByChannelFulfillmentGroup: true }
        );

        if (productAvailabilitesNonPlantsCNC && productAvailabilitesNonPlantsCNC.AggregatedProductInventoryAvailabilities) {
            productAvailabilitesNonPlantsCNC.AggregatedProductInventoryAvailabilities.map(stores => {
                if (stores.ProductId === productId && stores.PhysicalAvailableInventoryLevelCode !== 'OOS') {
                    deliveryOptions
                        .find(option => option.ProductId === productId)
                        ?.DeliveryOptions?.map(option => {
                            if (option.Code === 'ClickCol') {
                                setIsCnCProductAvailable(true);
                            }
                        });
                }
            });
            const mappedInventory = mapProductInventoryInformation(
                props.context.actionContext,
                productAvailabilitesNonPlantsCNC.ProductWarehouseInventoryAvailabilities || []
            );
            setProductAvailabilitesForCNC(mappedInventory);
            if (
                isLowStock(
                    productId,
                    mappedInventory,
                    props.context.actionContext.requestContext.app.config.warehouseIdsForFulfillment.map((x: string) => x.toLowerCase()),
                    false
                )
            ) {
                setIsCNCLowStock(true);
            }
        }
        setIsLoading(false);
    };
    if (counter === 0) {
        counter++;
        isCncAvailable();
    }

    useEffect(() => {
        if (product.result?.RecordId) {
            const isISO =
                productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() ===
                'yes';
            const isCnC = props.data.deliveryOptions.result?.DeliveryOptions?.some(opt => opt.Code === 'ClickCol');
            getAddToCartBoxes(
                DeliveryBoxesType.PDP,
                product.result.RecordId,
                isHomeDelTileSelected,
                isCNCTileSelected,
                (!isISO && isProductAvailable) || false,
                (isCnCProductAvailable && isCnC) || false,
                props.context.actionContext,
                updateModeOfAddToCart,
                isHomeDelLowStock,
                isCNCLowStock
            ).then(res => {
                setAddToCartTiles(res);
            });
        }
    }, [isCnCProductAvailable]);

    const updateStateQuantity = () => {
        const cncInventory =
            productAvailabilitesForCNC &&
            productAvailabilitesForCNC?.find(
                inventory => inventory.InventLocationId === selectedCNCOrgUnitLoc?.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId
            );
        let productInventory = props.data.productAvailableQuantity.result?.find(
            inventory => inventory.ProductAvailableQuantity.ProductId === product.result?.RecordId
        );
        if (isCNCTileSelected && cncInventory) {
            productInventory = cncInventory;
        }
        let isOverMaxQuantity = false;
        let maxQuantity = 1;
        if (
            productInventory &&
            productInventory.ProductAvailableQuantity.AvailableQuantity &&
            productInventory.ProductAvailableQuantity.AvailableQuantity < props.context.app.config.maxQuantityForCartLineItem
        ) {
            isOverMaxQuantity = state.quantity > productInventory?.ProductAvailableQuantity.AvailableQuantity;
            maxQuantity = productInventory?.ProductAvailableQuantity.AvailableQuantity;
        } else {
            isOverMaxQuantity = state.quantity > props.context.app.config.maxQuantityForCartLineItem;
            maxQuantity = props.context.app.config.maxQuantityForCartLineItem;
        }

        // Reseting the selected quantity to max available quantity if the selected quantity is over max quantity after changing delivery option (CNC -> Home or Home -> CNC)
        if (isOverMaxQuantity) {
            callbacks.updateQuantity(maxQuantity);
        }
    };

    useEffect(() => {
        if (product.result?.RecordId) {
            const isISO =
                productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() ===
                'yes';
            const isCnC = props.data.deliveryOptions.result?.DeliveryOptions?.some(opt => opt.Code === 'ClickCol');
            getAddToCartBoxes(
                DeliveryBoxesType.PDP,
                product.result.RecordId,
                isHomeDelTileSelected,
                isCNCTileSelected,
                (!isISO && isProductAvailable) || false,
                (isCnCProductAvailable && isCnC) || false,
                props.context.actionContext,
                updateModeOfAddToCart,
                isHomeDelLowStock,
                isCNCLowStock
            ).then(res => {
                setAddToCartTiles(res);
            });
        }
    }, [isHomeDelTileSelected, isCNCTileSelected]);

    useEffect(() => {
        updateStateQuantity();
    }, [isHomeDelTileSelected, isCNCTileSelected, selectedCNCOrgUnitLoc]);

    useEffect(() => {
        if (product.result?.RecordId) {
            const isISO =
                productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() ===
                'yes';
            const isCnC = props.data.deliveryOptions.result?.DeliveryOptions?.some(opt => opt.Code === 'ClickCol');
            getAddToCartBoxes(
                DeliveryBoxesType.PDP,
                product.result.RecordId,
                isHomeDelTileSelected,
                isCNCTileSelected,
                (!isISO && isProductAvailable) || false,
                (isCnCProductAvailable && isCnC) || false,
                props.context.actionContext,
                updateModeOfAddToCart,
                isHomeDelLowStock,
                isCNCLowStock
            ).then(res => {
                setAddToCartTiles(res);
            });
        }
    }, [isHomeDelLowStock, isCNCLowStock]);

    const _renderPlantaBlock = (): JSX.Element => {
        return (
            <div className='planta-container'>
                <div className='col-4'>
                    <img
                        width='90%'
                        src={
                            props.config.plantaImageUrl
                                ? props.config.plantaImageUrl
                                : 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/nctrkxsknc/imageFileData/ME1Dsl?ver=e893'
                        }
                    />
                </div>
                <div className='col-8'>
                    <h2>Planta: Never kill a plant again</h2>
                    <br />
                    <p>
                        Individuals care schedule and reminders for your plants, recommendations, step by step guides, identification, light
                        meter and more. Keep your plants alive with Planta!
                    </p>
                    <br />

                    {platform === 'Web' ? (
                        <div className='row '>
                            <a className='planta-app-btn' href={googlePlayUrl} target='_blank'>
                                <img
                                    src={
                                        props.config.googlePlayImageUrl
                                            ? props.config.googlePlayImageUrl
                                            : 'https://texttofloss.com/wp-content/uploads/2021/01/Google-Play-Store-Button-300x98.png'
                                    }
                                />
                            </a>
                            <a className='planta-app-btn' href={appleStoreUrl} target='_blank'>
                                <img
                                    src={
                                        props.config.appleStoreImageUrl
                                            ? props.config.appleStoreImageUrl
                                            : 'https://www.mipic.co/blog/wp-content/uploads/2019/07/app-store-icon-png-14.png'
                                    }
                                />
                            </a>
                        </div>
                    ) : (
                        <a href={platform === 'Android' ? googlePlayUrl : appleStoreUrl}>
                            <div className='row '>
                                <img
                                    className='planta-app-btn'
                                    src={
                                        props.config.googlePlayImageUrl
                                            ? props.config.googlePlayImageUrl
                                            : 'https://texttofloss.com/wp-content/uploads/2021/01/Google-Play-Store-Button-300x98.png'
                                    }
                                />
                                <img
                                    className='planta-app-btn'
                                    src={
                                        props.config.appleStoreImageUrl
                                            ? props.config.appleStoreImageUrl
                                            : 'https://www.mipic.co/blog/wp-content/uploads/2019/07/app-store-icon-png-14.png'
                                    }
                                />
                            </div>
                        </a>
                    )}
                </div>
            </div>
        );
    };

    const _renderAddToCartContainer = () => {
        // const comingSoonCategoryName: string | undefined = props.config.comingSoonCategoryName;
        // if (comingSoonCategoryName) {
        //     const comingSoonAttr = productAttributes.result?.find(
        //         attr => attr.Name?.toLowerCase() === comingSoonCategoryName?.toLowerCase()
        //     );
        //     // if (comingSoonAttr && comingSoonAttr.TextValue?.toLowerCase() === 'yes') {
        //     //     return <></>;
        //     // }
        // }

        const deliveryOptions = props.data.deliveryOptions?.result?.DeliveryOptions;
        const isCnC = deliveryOptions?.some(opt => opt.Code === 'ClickCol');
        const isISO =
            productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() === 'yes';
        const outOfSeason =
            productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'outofseason')?.TextValue?.toLowerCase() === 'yes';
        const outOfSeasonCheck = outOfSeason && !isProductAvailable;
        if (!(isProductAvailable && addToCart && !isISO) && isCnC) {
            const cookies = props.context.actionContext.requestContext.cookies;
            const cncProducts = cookies.get('cnc_products').value || [];
            if (Array.isArray(cncProducts) && !cncProducts.includes(product.result?.ItemId)) {
                cncProducts.push(product.result?.ItemId);
            }
            cookies.set('cnc_products', cncProducts);
        }
        const cncInventory =
            productAvailabilitesForCNC &&
            productAvailabilitesForCNC?.find(
                inventory => inventory.InventLocationId === selectedCNCOrgUnitLoc?.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId
            );
        let productInventory = props.data.productAvailableQuantity.result?.find(
            inventory => inventory.ProductAvailableQuantity.ProductId === product.result?.RecordId
        );
        if (isCNCTileSelected && cncInventory) {
            productInventory = cncInventory;
        }
        let isMaxQuantityReached = false;
        if (
            productInventory &&
            productInventory.ProductAvailableQuantity.AvailableQuantity &&
            productInventory.ProductAvailableQuantity.AvailableQuantity < props.context.app.config.maxQuantityForCartLineItem
        ) {
            isMaxQuantityReached = state.quantity >= productInventory?.ProductAvailableQuantity.AvailableQuantity;
        } else {
            isMaxQuantityReached = state.quantity >= props.context.app.config.maxQuantityForCartLineItem;
        }
        return (
            <div className='add-to-cart-container'>
                {/* {!outOfSeasonCheck && findInStore && _renderFindInStore(findInStore)} */}
                {isEcomProductAvailable || isCnCProductAvailable ? (
                    <>
                        {(isMaxQuantityReached || props.state.errorState.quantityError) && (isHomeDelTileSelected || isCNCTileSelected) ? (
                            <div className='notification-alert max-quantity-notification notification-alert__yellow'>
                                <div className='notification-alert__message'>
                                    <p className='notification-alert__message--paragraph'>You’ve reached the maximum quantity available.</p>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                        {isISO || (!outOfSeasonCheck && (isProductAvailable || isISO || isCnCProductAvailable)) ? (
                            <Node
                                tag='div'
                                className={classnames(
                                    'price-quantity',
                                    !isVendorShipped && 'instore-product',
                                    'purchase-buttons',
                                    isCnC ? 'cnc' : 'no-cnc'
                                )}
                            >
                                {quantity &&
                                    _renderQuantity(
                                        quantity,
                                        callbacks,
                                        props,
                                        state,
                                        resources,
                                        isCNCTileSelected,
                                        selectedCNCOrgUnitLoc,
                                        productAvailabilitesForCNC
                                    )}

                                <Node tag='div' className={`buttons-container ${isCnC ? 'cnc' : 'no-cnc'}`}>
                                    <div>{((addToCart && !isISO) || isISO || isCnCProductAvailable) && _renderAddToCart(addToCart)}</div>
                                    {/* {CnCPickupIds.includes(location.ChannelId)	
                                    ? isCnC && isCnCProductAvailable && findInStore?.clickAndCollect	
                                    : ''} */}
                                </Node>
                            </Node>
                        ) : (
                            <></>
                        )}

                        {
                            <div
                                className={`additional-links ${
                                    props.context.actionContext.requestContext.user.isAuthenticated ? '' : 'guest-user'
                                }`}
                            >
                                {!outOfSeasonCheck && findInStore?.checkStock}
                                {!outOfSeasonCheck &&
                                    props.context.actionContext.requestContext.user.isAuthenticated &&
                                    addToWishlist &&
                                    _renderAddToWishlist(addToWishlist)}
                            </div>
                        }
                    </>
                ) : (
                    <></>
                )}

                <Node className='modal-links'>
                    {!isEcomProductAvailable && !isCnCProductAvailable ? (
                        <div className='out-of-stock'>
                            <p className='out-of-stock__heading'>
                                {!isProductAvailable && !isCnCProductAvailable ? 'Temporarily out of stock online' : ''}
                            </p>
                            {!outOfSeasonCheck && findInStore?.checkStock}
                            <span>or</span>

                            <button
                                className='email-me'
                                onClick={handleNotifyMeClick}
                                color='secondary'
                                aria-label='Email me when available'
                            >
                                Email me when available
                            </button>

                            {!outOfSeasonCheck &&
                                props.context.actionContext.requestContext.user.isAuthenticated &&
                                addToWishlist &&
                                _renderAddToWishlist(addToWishlist)}
                        </div>
                    ) : (
                        <></>
                    )}
                </Node>
                {/* <Node className={isError ? 'msc-add-to-cart-error __add-to-cart-error-alert' : ''}>{errorBlock}</Node> */}
            </div>
        );
    };
    if (props.data) {
        if (Array.isArray(props.data.productAvailableQuantity.result)) {
            for (let inventoryIter = 0; inventoryIter < props.data.productAvailableQuantity.result.length; inventoryIter++) {
                if (props.data.productAvailableQuantity.result[inventoryIter].StockLevelLabel === 'LOW') {
                    setIsHomeDelLowStock(true);
                    break;
                }
            }
        }
    }

    let hideYmlUnbxd: boolean | undefined = false;

    if (props.config?.checkStockForYmlUnbxd) {
        hideYmlUnbxd = !isEcomProductAvailable && !isCnCProductAvailable;
    }
    if (!addToCartTiles) {
        if (product.result?.RecordId) {
            const isISO =
                productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() ===
                'yes';
            const isCnC = props.data.deliveryOptions.result?.DeliveryOptions?.some(opt => opt.Code === 'ClickCol');
            getAddToCartBoxes(
                DeliveryBoxesType.PDP,
                product.result.RecordId,
                isHomeDelTileSelected,
                isCNCTileSelected,
                (isProductAvailable && !isISO) || false,
                (isCnCProductAvailable && isCnC) || false,
                props.context.actionContext,
                updateModeOfAddToCart,
                isHomeDelLowStock,
                isCNCLowStock
            ).then(res => {
                setAddToCartTiles(res);
            });

            let addressPostcode: string | undefined = '';
            if (props.context.actionContext.requestContext.user.isAuthenticated) {
                if (props.data.customerInformation?.result?.Addresses && props.data.customerInformation?.result?.Addresses.length) {
                    let customerAddress;
                    customerAddress =
                        props.data.customerInformation?.result?.Addresses.find(addr => addr.IsPrimary) ||
                        props.data.customerInformation?.result?.Addresses[0];

                    addressPostcode = customerAddress?.ZipCode;
                }
            }
            getEstimatedArrivalBy(product.result.RecordId, props.context.actionContext, addressPostcode)
                .then((res: React.SetStateAction<string>) => {
                    if (addressPostcode && loggedInZipCode !== addressPostcode) {
                        setLoggedinZipCode(addressPostcode);
                    }
                })
                .catch(() => {});
        }
    }

    const [screenSize, setScreenSize] = useState(0); // mobile first approach

    useEffect(() => {
        if (!MsDyn365.isBrowser) {
            return;
        }

        setScreenSize(_getScreenSize(props.context));

        const handleResize = () => {
            const newScreenSize = _getScreenSize(props.context);
            setScreenSize(newScreenSize);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [props.context]);

    const isMobiles = screenSize === 1;
    const isISO =
        productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() === 'yes';

    const baseImageUrl: string = props.context.request.apiSettings.baseImageUrl;
    const fallbackImageUrl = product && getFallbackImageUrl(product.result?.ItemId, props.context.actionContext.requestContext.apiSettings);
    const imageSettings = {
        viewports: {
            xs: { q: 'w=148&h=208&m=6', w: 0, h: 0 },
            sm: { q: 'w=148&h=208&m=6', w: 0, h: 0 },
            lg: { q: 'w=148&h=208&m=6', w: 0, h: 0 }
        },
        lazyload: true
    };
    const carouselHeading = get(props, 'slots.unbxdAlsoLikeCarousel[0].props.config.carouselHeading');
    const carouselHeadingHref =
        carouselHeading &&
        carouselHeading
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');

    /* VSI Customization - END - 18/01/21 */
    const stickyRef = useRef<HTMLDivElement | null>(null);
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const trigger = document.querySelector('.ms-buybox__content .price-quantity');
            const footer = document.querySelector('footer');
            if (!trigger || !footer) return;

            const triggerRect = trigger.getBoundingClientRect();
            const footerRect = footer.getBoundingClientRect();
            const hasPassedTrigger = triggerRect.bottom <= 0;
            const footerInView = footerRect.top <= window.innerHeight;
            // When trigger scrolls past the top
            if (hasPassedTrigger && !footerInView) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const clearCncSelection = () => {
        removeSelectedCncCookie();
        setIsCNCTileSelected(false);
        setSelectedCNCOrgUnitLoc(undefined);
        setIsHomeDelTileSelected(true);
    };

    const restrictedPostcodeAttr = productAttributes.result?.find(pa => pa.Name === 'RestrictedPostCode');
    const restrictedPostcodeTextVal = restrictedPostcodeAttr?.TextValue;
    let postcodesArr: string[] = [];
    if (restrictedPostcodeTextVal) {
        postcodesArr = JSON.parse(restrictedPostcodeTextVal).RestrictedPostCode;
    }
    const comingSoonCategoryName: string | undefined = props.config.comingSoonCategoryName;
    const comingSoonAttr =
        productAttributes.result
            ?.find(attr => attr.Name?.toLowerCase() === comingSoonCategoryName?.toLowerCase())
            ?.TextValue?.toLowerCase() === 'yes';

    const alternateAddressBtn = (
        <Button
            className='alternate-address'
            onClick={() => {
                setShowAlternativeInfo(true);
            }}
        ></Button>
    );

    const outOfSeason =
        productAttributes.result?.find(attr => attr.Name?.toLocaleLowerCase() === 'outofseason')?.TextValue?.toLowerCase() === 'yes';
    const outOfSeasonCheck = outOfSeason && !isProductAvailable;

    return (
        <>
            <Module {...ModuleProps}>
                {(isCnCProductAvailable || isEcomProductAvailable) && (
                    <div ref={stickyRef} className={`sticky-product-detail ${isSticky ? 'sticky' : ''}`}>
                        <div className='container'>
                            <div className='product-detail'>
                                <div className='image'>
                                    <Msdyn365.Image
                                        src={`${baseImageUrl}${product.result?.PrimaryImageUrl}` || ''}
                                        fallBackSrc={fallbackImageUrl}
                                        altText={product.result?.Name}
                                        gridSettings={props.context.request.gridSettings!}
                                        imageSettings={imageSettings}
                                        loadFailureBehavior='empty'
                                    />
                                </div>
                                <div className='detail'>
                                    <div className='title-price'>
                                        <div className='title'>{_renderProductTitle()}</div>
                                        {props.price}
                                    </div>
                                    {
                                        <div className='delivery-add-to-cart'>
                                            <div
                                                className={`delivery-methods ${
                                                    !isCnCProductAvailable && !isISO
                                                        ? 'only-hd-available'
                                                        : onlyCNCAvailable
                                                        ? 'only-in-store'
                                                        : ''
                                                }`}
                                            >
                                                {!isISO && (
                                                    <div
                                                        className={`home ${!isEcomProductAvailable ? 'disabled' : ''}`}
                                                        onClick={() => {
                                                            if (!isEcomProductAvailable) {
                                                                return;
                                                            }
                                                            clearCncSelection();
                                                        }}
                                                    >
                                                        <input
                                                            type='radio'
                                                            id='home'
                                                            name='delivery-method'
                                                            value='home'
                                                            checked={isHomeDelTileSelected}
                                                            disabled={!isEcomProductAvailable}
                                                        />
                                                        <span className='checkmark'></span>
                                                        <label htmlFor='home'>Home Delivery</label>
                                                    </div>
                                                )}

                                                {(isISO || isCnCProductAvailable) && (
                                                    <div
                                                        className={`cnc ${!isCnCProductAvailable ? 'disabled' : ''}`}
                                                        onClick={() => {
                                                            if (!isCnCProductAvailable) {
                                                                return;
                                                            }
                                                            setIsCNCTileSelected(true);
                                                            setIsHomeDelTileSelected(false);
                                                        }}
                                                    >
                                                        <input
                                                            type='radio'
                                                            id='cnc'
                                                            name='delivery-method'
                                                            value='cnc'
                                                            checked={isCNCTileSelected}
                                                            disabled={!isCnCProductAvailable}
                                                        />
                                                        <span className='checkmark'></span>
                                                        <label htmlFor='cnc'>Free Click & Collect</label>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='add-to-cart'>{_renderAddToCartContainer()}</div>
                                            {addToCart && addToCart.addedToCartModal}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='links'>
                            <div className='container'>
                                <ul>
                                    <li>
                                        <a
                                            href='#product-details'
                                            onClick={e => {
                                                e.preventDefault();
                                                const hash = '#product-details';
                                                window.history.replaceState(null, '', hash);
                                                document
                                                    .getElementById(hash.slice(1))
                                                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                            }}
                                        >
                                            Product Details
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href='#delivery-returns'
                                            onClick={e => {
                                                e.preventDefault();
                                                const id = 'delivery-returns';
                                                const el = document.getElementById(id);
                                                if (el) {
                                                    el.dispatchEvent(new CustomEvent('openAccordion', { bubbles: true }));
                                                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                }
                                            }}
                                        >
                                            Delivery &amp; returns
                                        </a>
                                    </li>

                                    {(props.data.getUnbxdRecommendationsCount?.result?.count ?? 0) > 0 && !hideYmlUnbxd && (
                                        <li>
                                            <a href={`#${carouselHeadingHref}`}>{carouselHeading}</a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
                {isMobiles && (
                    <div className='ms-buybox__content mobile'>
                        {!isLoading && (
                            <VsiCustomBadges
                                productData={props.data.product.result}
                                context={props.context}
                                isProductAvailableCNC={isCnCProductAvailable}
                                isProductAvailableEcom={isEcomProductAvailable}
                                isISO={isISO}
                                mode='text'
                            />
                        )}
                        <Node className='ms-buybox__product-title' tag='h1'>
                            {_renderProductTitle()}
                        </Node>

                        {/* {title} */}
                        <div className='product-badge-pdp-container'>
                            {props.price}

                            {checkUserDiscounts && checkUserDiscounts[0] && checkUserLoyalty === undefined && (
                                <div className='product-badge-pdp'>
                                    <div
                                        className={
                                            displayClubPlusInfo
                                                ? 'product-card-club-plus-badge-pdp badge-collapse-pdp'
                                                : 'product-card-club-plus-badge-pdp'
                                        }
                                    >
                                        {displayClubPlusInfo && (
                                            <div className='product-club-plus-container-info-pdp'>
                                                <div onClick={() => displayClubPlus()} className='product-card-club-plus-cross-pdp'></div>
                                                <Msdyn365.RichTextComponent
                                                    className='product-club-plus-info-pdp'
                                                    text={props.config.priceTooltipText}
                                                />
                                            </div>
                                        )}
                                        <div className='product-card-club-plus-pdp'>
                                            <p className='product-club-plus'>
                                                Club Plus Price{' '}
                                                <span className='product-card-club-plus-price-pdp'>£{renderClubPlusBadges()}</span>
                                            </p>

                                            <div
                                                onClick={() => displayClubPlus()}
                                                className={
                                                    displayClubPlusInfo
                                                        ? `product-card-club-plus-icon-pdp product-card-club-plus-icon-pdp-close`
                                                        : `product-card-club-plus-icon-pdp`
                                                }
                                            >
                                                <p>{!displayClubPlusInfo && '?'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {checkUserDiscounts && checkUserDiscounts[0] && checkUserLoyalty && (
                                <div className='product-badge-pdp'>
                                    <div className='product-card-club-plus-pdp'>
                                        <p className='product-club-plus'>
                                            Club Plus Price{' '}
                                            <span className='product-card-club-plus-price-pdp'>£{renderClubPlusBadges()}</span>
                                        </p>
                                    </div>
                                </div>
                            )}
                            {/* {isShowPaypalBanner && paypalBannerImageDesktop?.src && (
                                <a
                                    className='pdp-paypal-banner'
                                    href={paypalBannerLink?.linkUrl.destinationUrl}
                                    target={paypalBannerLink?.openInNewTab ? '_blank' : undefined}
                                    aria-label={paypalBannerLink?.ariaLabel}
                                >
                                    <img src={paypalBannerImageDesktop?.src || ''} />
                                </a>
                            )} */}
                        </div>
                    </div>
                )}
                {!outOfSeasonCheck && findInStore && _renderFindInStore(findInStore)}
                <div ref={mediaGalleryRef} className='ms-buybox__media-gallery'>
                    {props.mediaGallery}
                </div>
                <Node {...ProductInfoContainerProps}>
                    {!isMobiles && (
                        <>
                            {!isLoading && (
                                <VsiCustomBadges
                                    productData={props.data.product.result}
                                    context={props.context}
                                    isProductAvailableCNC={isCnCProductAvailable}
                                    isProductAvailableEcom={isEcomProductAvailable}
                                    isISO={isISO}
                                    mode='text'
                                />
                            )}
                            <Node className='ms-buybox__product-title' tag='h1'>
                                {_renderProductTitle()}
                            </Node>

                            {/* {title} */}
                            <div className='product-badge-pdp-container'>
                                {props.price}

                                {checkUserDiscounts && checkUserDiscounts[0] && checkUserLoyalty === undefined && (
                                    <div className='product-badge-pdp'>
                                        <div
                                            className={
                                                displayClubPlusInfo
                                                    ? 'product-card-club-plus-badge-pdp badge-collapse-pdp'
                                                    : 'product-card-club-plus-badge-pdp'
                                            }
                                        >
                                            {displayClubPlusInfo && (
                                                <div className='product-club-plus-container-info-pdp'>
                                                    <div
                                                        onClick={() => displayClubPlus()}
                                                        className='product-card-club-plus-cross-pdp'
                                                    ></div>
                                                    <Msdyn365.RichTextComponent
                                                        className='product-club-plus-info-pdp'
                                                        text={props.config.priceTooltipText}
                                                    />
                                                </div>
                                            )}
                                            <div className='product-card-club-plus-pdp'>
                                                <p className='product-club-plus'>
                                                    Club Plus Price{' '}
                                                    <span className='product-card-club-plus-price-pdp'>£{renderClubPlusBadges()}</span>
                                                </p>

                                                <div
                                                    onClick={() => displayClubPlus()}
                                                    className={
                                                        displayClubPlusInfo
                                                            ? `product-card-club-plus-icon-pdp product-card-club-plus-icon-pdp-close`
                                                            : `product-card-club-plus-icon-pdp`
                                                    }
                                                >
                                                    <p>{!displayClubPlusInfo && '?'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {checkUserDiscounts && checkUserDiscounts[0] && checkUserLoyalty && (
                                    <div className='product-badge-pdp'>
                                        <div className='product-card-club-plus-pdp'>
                                            <p className='product-club-plus'>
                                                Club Plus Price{' '}
                                                <span className='product-card-club-plus-price-pdp'>£{renderClubPlusBadges()}</span>
                                            </p>
                                        </div>
                                    </div>
                                )}
                                {/* {isShowPaypalBanner && paypalBannerImageDesktop?.src && (
                                    <a
                                        className='pdp-paypal-banner'
                                        href={paypalBannerLink?.linkUrl.destinationUrl}
                                        target={paypalBannerLink?.openInNewTab ? '_blank' : undefined}
                                        aria-label={paypalBannerLink?.ariaLabel}
                                    >
                                        <img src={paypalBannerImageDesktop?.src || ''} />
                                    </a>
                                )} */}
                            </div>
                        </>
                    )}
                    {!props.context.app.config.hideRating && (
                        <Node tag='div' className='rating-holder'>
                            {!props.context.app.config.hideRating && rating}
                            {!props.context.app.config.hideRating && _renderReviewCount(reviewsCount, resources)}
                        </Node>
                    )}
                    {configure && _renderConfigure(configure)}
                    <div className='links'>
                        <a
                            href='#key-features'
                            onClick={e => {
                                e.preventDefault();
                                const id = 'key-features';
                                const el = document.getElementById(id);
                                if (el) {
                                    el.dispatchEvent(new CustomEvent('openAccordion', { bubbles: true }));
                                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            }}
                        >
                            Key features
                        </a>
                        <a
                            href='#delivery-returns'
                            onClick={e => {
                                e.preventDefault();
                                const id = 'delivery-returns';
                                const el = document.getElementById(id);
                                if (el) {
                                    el.dispatchEvent(new CustomEvent('openAccordion', { bubbles: true }));
                                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            }}
                        >
                            Delivery &amp; returns
                        </a>
                    </div>
                    {/* VSI Customization - START - 27/10/20 */}
                    {/* FALSE TO HIDE NOTIFY ME BUTTON  */}

                    {(isISO || isEcomProductAvailable || isCnCProductAvailable) && (
                        <>
                            <div className='ms-buybox__dm'>
                                {!isCnCProductAvailable && !isISO ? (
                                    <p className='only-hd'>Product is only available for Home Delivery.</p>
                                ) : onlyCNCAvailable ? (
                                    <p className='only-cnc'>Product is only available for Click & Collect.</p>
                                ) : (
                                    ''
                                )}
                                <div
                                    className={`ms-buybox__delivery-methods ${
                                        !isCnCProductAvailable && !isISO ? 'only-hd-available' : onlyCNCAvailable ? 'only-in-store' : ''
                                    } ${isCNCTileSelected ? 'cnc' : ''} `}
                                >
                                    <div className='delivery-method-tiles'>{addToCartTiles}</div>
                                    {!isHomeDelTileSelected && !isCNCTileSelected ? (
                                        <p className='text-center choose-delivery-method'>Choose your delivery method.</p>
                                    ) : (
                                        ''
                                    )}

                                    {!isEcomProductAvailable && !isISO && !selectedCNCOrgUnitLoc && (
                                        <div className='d-flex justify-content-center mt-2'>
                                            <a
                                                className='email-me'
                                                onClick={handleNotifyMeClick}
                                                color='secondary'
                                                aria-label='Email me when available for Home Delivery'
                                            >
                                                <span className='msc-in-stock-red'></span>
                                                Email me when available for Home Delivery
                                            </a>
                                        </div>
                                    )}

                                    {!isISO && isHomeDelTileSelected && (isProductAvailable || getVendorName()) ? (
                                        <div className='home-del-selected'>
                                            {postcodesArr.some(postcode => loggedInZipCode.startsWith(postcode)) ? (
                                                <div className='notification-alert notification-alert__yellow'>
                                                    <div className='notification-alert__message'>
                                                        <p className='notification-alert__message--paragraph'>
                                                            This item cannot be delivered to some postcodes. Please click{' '}
                                                            <a href='/delivery-information'>here</a> for more details.
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                            <p className='dispatched-by'>
                                                <a href={getVendorName() ? '/approved-suppliers' : '/delivery-information'}>
                                                    <span>Dispatched by: {getVendorName() || 'Dobbies'}</span>
                                                </a>
                                            </p>
                                            {loggedInZipCode ? (
                                                <div className='d-flex justify-content-center'>
                                                    <div className={`alternative-address-info ${showAlternativeInfo ? 'show' : ''}`}>
                                                        <button
                                                            onClick={() => {
                                                                setShowAlternativeInfo(false);
                                                            }}
                                                            className='alternative-address-info--close'
                                                        />
                                                        <p>
                                                            An alternative delivery address can be <br /> added at checkout.
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                            <div className='w-100'>
                                                <ProductArrivalEstimate
                                                    productId={product.result?.RecordId || 0}
                                                    actionContext={props.context.actionContext}
                                                    loggedInZipCode={
                                                        props.data.customerInformation.result?.Addresses?.find(addr => addr.IsPrimary)
                                                            ?.ZipCode ?? ''
                                                    }
                                                    alternateAddressBtn={alternateAddressBtn}
                                                />
                                            </div>
                                            <p className='delivery-fee'>
                                                If delivery fees apply, you’ll see them in your basket before checkout.
                                            </p>
                                            {loggedInZipCode && getDelayedDeliveryMsg(props.context.actionContext, loggedInZipCode) && (
                                                <p className='delivery-note'>
                                                    {getDelayedDeliveryMsg(props.context.actionContext, loggedInZipCode)}
                                                </p>
                                            )}
                                        </div>
                                    ) : isCNCTileSelected && (isCnCProductAvailable || isISO) ? (
                                        <div className='cnc-selected'>
                                            {selectedCNCOrgUnitLoc ? (
                                                <>
                                                    <div>
                                                        In-stock:
                                                        <b className='ml-1 mr-1'>
                                                            {props.config.storeNamePrefix}
                                                            {selectedCNCOrgUnitLoc.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName}.
                                                        </b>
                                                        <a
                                                            className='choose-store'
                                                            onClick={() => {
                                                                if (findInStore?.clickCNC) {
                                                                    findInStore.clickCNC();
                                                                }
                                                            }}
                                                        >
                                                            Change store
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                            <p>
                                                We’ll email when your order is ready.{' '}
                                                <a
                                                    href={
                                                        props.context.actionContext.requestContext.app.config.cartLineLearnMoreLink || '#'
                                                    }
                                                    target='_blank'
                                                >
                                                    Learn more
                                                </a>
                                            </p>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {isAgeRestricted === true && _renderTextBlock(ageRestrictionNotification)}

                    {_renderAddToCartContainer()}
                    {hideYmlUnbxd &&
                    props.slots.unbxdAlsoLikeCarousel &&
                    !comingSoonAttr &&
                    props.slots.unbxdAlsoLikeCarousel.length > 0 ? (
                        <div className='unbxd-recommendations outofstock'>{props.slots.unbxdAlsoLikeCarousel}</div>
                    ) : null}
                    {showBackInStockModal && (
                        <DobbiesModal
                            isOpen={showBackInStockModal}
                            modalTitle={_renderPopupTitle()}
                            modalBodyElement={_renderPopupBody()}
                            modalFooter={_renderPopupFooter()}
                            className='ms-dobbies-newsletter-popup backinstock-modal modal'
                        />
                    )}
                    {productAddedToCart && _renderAddedToCartNotification(resources, navigationUrl)}
                    {/* Render notification only if age restriction attribute is true */}

                    {(isEcomProductAvailable || isCnCProductAvailable) && <RenderBanners {...props} />}
                    {_renderTextBlock(props.slots.textBlocks)}
                    {!isQuickView && (
                        <>
                            {false && _renderPlantaBlock()}

                            {/* VSI Customization - END - 10/11/20 */}
                            {_renderSocialShare(props.slots && props.slots.socialShare)}
                            {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                        </>
                    )}
                </Node>
                {/* {!isQuickView && _renderSchema(product?.result, allAttributes, pageUrl, imageUrl, ratingsSummary?.result, productPrice?.result)} */}
            </Module>
            {productDetails}
            {!allBundleProductsOOS && bundleHasProducts && (
                <div className='product-bundle-wrapper'>
                    <div className='product-bundle'>
                        <h2 className='product-bundle__heading'>You might also like…</h2>
                        <div className='product-bundle-container'>
                            <div className='product-bundle-left'>
                                {props.slots.bundledProductsSlot && props.slots.bundledProductsSlot[0]}
                            </div>
                            {props.slots.bundledProductsSlot && (
                                <div className='price-summary-wrapper'>
                                    <div className={`price-summary ${isVirtualCartEmpty() ? 'empty' : ''}`}>
                                        <h3>
                                            {props.config.productBundlesOrderSummaryText
                                                ? props.config.productBundlesOrderSummaryText
                                                : 'Price summary'}
                                        </h3>

                                        {_renderCartLines(
                                            props.data.cart.result?.cart.CartLines ? props.data.cart.result?.cart.CartLines : [],
                                            props,
                                            cartProducts,
                                            setCartProducts,
                                            bundlesSummaryScrollPos,
                                            setBundlesSummaryScrollPos,
                                            bundlesModalSummaryScrollPos,
                                            setBundlesModalSummaryScrollPos,
                                            false
                                        )}
                                        <Button
                                            className='msc-add-to-cart'
                                            disabled={isVirtualCartEmpty() || isMaximumQuantityAdded()}
                                            title='Buy All'
                                            onClick={() => {
                                                _addAllProductsToCart();
                                            }}
                                        >
                                            {isVirtualCartEmpty() ? 'Add an item' : 'Add to basket'}
                                        </Button>
                                        <p>
                                            {props.config.discountAppliedInCartMessage
                                                ? props.config.discountAppliedInCartMessage
                                                : 'Any offers/discounts will be applied in basket'}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {!allBundleProductsOOS &&
                bundleModalHasProducts &&
                props.context.app.config.showProductBundlesInModal &&
                props.slots.bundledProductsModalSlot &&
                props.slots.bundledProductsModalSlot[0] && (
                    <Modal className='product-bundle-modal' isOpen={renderProductBundlesModal} toggle={closeProductBundlesModal}>
                        <ModalBody>
                            <div className='product-bundle-wrapper'>
                                <div className='product-bundle'>
                                    <button
                                        type='button'
                                        className='close-modal'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={closeProductBundlesModal}
                                    ></button>
                                    <h2 className='product-bundle__heading'>You might also like…</h2>
                                    <div className='product-bundle-container'>
                                        <div className='product-bundle-left'>
                                            {props.slots.bundledProductsModalSlot && props.slots.bundledProductsModalSlot[0]}
                                        </div>
                                        <div className='price-summary-wrapper'>
                                            <div
                                                className={`price-summary ${
                                                    !props.data.cart.result?.cart.CartLines?.length ? 'empty' : ''
                                                }`}
                                            >
                                                <h3>Your basket</h3>
                                                {_renderCartLines(
                                                    props.data.cart.result?.cart.CartLines ? props.data.cart.result?.cart.CartLines : [],
                                                    props,
                                                    cartProducts,
                                                    setCartProducts,
                                                    bundlesSummaryScrollPos,
                                                    setBundlesSummaryScrollPos,
                                                    bundlesModalSummaryScrollPos,
                                                    setBundlesModalSummaryScrollPos,
                                                    true
                                                )}
                                                <Button
                                                    className='msc-add-to-cart'
                                                    disabled={!props.data.cart.result?.cart.CartLines?.length ? true : false}
                                                    title='Buy All'
                                                    onClick={() => {
                                                        MsDyn365.isBrowser && window && window.location.assign('/cart');
                                                    }}
                                                >
                                                    {!props.data.cart.result?.cart.CartLines?.length ? 'Add an item' : 'View your basket'}
                                                </Button>
                                                <p>
                                                    {props.config.discountAppliedInCartMessage
                                                        ? props.config.discountAppliedInCartMessage
                                                        : 'Any offers/discounts will be applied at checkout'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        {/* <ModalFooter /> */}
                    </Modal>
                )}
            {/* Display default YMAL and hide  top ymal carousel*/}
            {!hideYmlUnbxd && props.slots.unbxdAlsoLikeCarousel && props.slots.unbxdAlsoLikeCarousel.length > 0 ? (
                <div id={carouselHeadingHref} className='unbxd-recommendations' style={{ scrollMarginTop: '50px' }}>
                    {props.slots.unbxdAlsoLikeCarousel}
                </div>
            ) : null}
        </>
    );
};

const _getAllStores = async (
    props: IBuyboxProps<IBuyboxData & IBuyboxViewData>,
    latitude?: number,
    longitude?: number,
    radius?: number,
    distanceUnitValue?: number
): Promise<IFullOrgUnitAvailability[]> => {
    const {
        context: { actionContext }
    } = props;

    const orgUnitLocationsInput = new GetAllOrgUnitLocationsByAreaInput(latitude, longitude, radius, distanceUnitValue, false);
    const orgUnitLocations = await getAllOrgUnitLocationsByArea(orgUnitLocationsInput, actionContext);
    return orgUnitLocations;
};

const changeQinBundlesModalSummary = async (
    props: IBuyboxProps<IBuyboxData & IBuyboxViewData>,
    productId: number,
    newValue: number,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    isSummaryInModal: boolean,
    maxQuantityForBundle: number
) => {
    const cartState = await getCartState(props.context.actionContext);
    const cl = cartState.cart.CartLines?.find(c => c.ProductId === productId);
    const simpleProduct: SimpleProduct | undefined = cartProducts.find(c => c.RecordId === productId);
    if (maxQuantityForBundle <= 0) {
        const cookies = props.context.actionContext.requestContext.cookies;
        const maxQuantities = cookies.get('product_bundles_maximum_available_quantities')?.value || [];
        if (Array.isArray(maxQuantities)) {
            for (const maxQ of maxQuantities) {
                if (maxQ.productId === productId) {
                    maxQuantityForBundle = maxQ.maxQuantity;
                    break;
                }
            }
        }
    }
    if (cl && cl.Quantity && maxQuantityForBundle && simpleProduct) {
        if (newValue > maxQuantityForBundle) {
            return;
        }
        const diffInQuantity = newValue - cl.Quantity;
        const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: props.context.actionContext, queryResultSettings: {} }, [
            productId
        ]);
        const emailDeliveryModeCode = props.context.actionContext.requestContext.channel?.EmailDeliveryModeCode;
        if (diffInQuantity > 0) {
            let addProductToCartInput = {
                product: simpleProduct,
                quantity: diffInQuantity,
                enableStockCheck: props.context.app.config.enableStockCheck,
                availableQuantity: maxQuantityForBundle,
                isAddEmailDeliveryItemToCart:
                    ArrayExtensions.hasElements(deliveryOptions) &&
                    ArrayExtensions.hasElements(deliveryOptions[0].DeliveryOptions) &&
                    deliveryOptions[0].DeliveryOptions[0].Code === emailDeliveryModeCode
            };
            const cookies = props.context.actionContext.requestContext.cookies;
            const cncProducts = cookies.get('cnc_products').value || [];
            if (Array.isArray(cncProducts) && cncProducts.includes(simpleProduct.ItemId)) {
                const deliveryOptions = await getDeliveryOptionsAsync(
                    { callerContext: props.context.actionContext, queryResultSettings: {} },
                    [simpleProduct.RecordId]
                );
                let cncOption: DeliveryOption | undefined;
                deliveryOptions.map(dopt => {
                    dopt.DeliveryOptions?.map(delOpt => {
                        if (delOpt.Code === 'ClickCol') {
                            cncOption = delOpt;
                        }
                    });
                });
                const sLocations = await _getAllStores(props, 31.5070767, 74.4315609, 0, 0);
                const storeLocation = sLocations.find(sl => {
                    return sl.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === cl.FulfillmentStoreId;
                });
                if (storeLocation && storeLocation.OrgUnitAvailability?.OrgUnitLocation) {
                    cartState
                        .addProductToCart({
                            product: simpleProduct,
                            count: diffInQuantity,
                            location: storeLocation.OrgUnitAvailability?.OrgUnitLocation,
                            deliveryMode: cncOption?.Code
                        })
                        .then(async result => {
                            if (result.status === 'SUCCESS') {
                                props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                            }
                        })
                        .catch(() => {});
                }
            } else {
                cartState
                    .addProductToCart(addProductToCartInput)
                    .then(async result => {
                        if (result.status === 'SUCCESS') {
                            props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                        }
                    })
                    .catch(() => {});
            }
        } else if (diffInQuantity < 0) {
            cartLineQuantityUpdatedAsync(true, cartState, props.context.actionContext.telemetry, [simpleProduct], cl, newValue)
                .then((cartActionResult: ICartActionResult | undefined): boolean => {
                    if (cartActionResult?.status === 'SUCCESS') {
                        props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                        return true;
                    }
                    return false;
                })
                .catch(() => {});
        }
    }
};
const onQuantityChange = async (
    props: IBuyboxProps<IBuyboxData & IBuyboxViewData>,
    productId: number,
    newValue: number,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    isSummaryInModal: boolean,
    maxQuantityForBundle: number
) => {
    if (isSummaryInModal) {
        changeQinBundlesModalSummary(props, productId, newValue, cartProducts, setCartProducts, isSummaryInModal, maxQuantityForBundle);
        return;
    }
    const cookies = props.context.actionContext.requestContext.cookies;
    const addedProductsToCollection = cookies.get('added_products_bundles')?.value || [];
    const cartProductsCopy = cartProducts.map(cp => cp);
    const updatedProducts: IDobbiesAddedProductToBundle[] = [];
    if (Array.isArray(addedProductsToCollection)) {
        for (const obj of addedProductsToCollection) {
            if (obj['productId'] === productId) {
                const valueToBeUpdated = newValue;
                if (valueToBeUpdated > 0) {
                    updatedProducts.push({
                        productId: obj['productId'],
                        price: obj['price'],
                        quantity: valueToBeUpdated,
                        maxQuantity: obj['maxQuantity'],
                        inventoryLocationId: obj['inventoryLocationId']
                    });
                    for (const cp of cartProductsCopy) {
                        if (cp.RecordId === obj['productId']) {
                            cp.quantity = valueToBeUpdated;
                        }
                    }
                }
            } else {
                updatedProducts.push({
                    productId: obj['productId'],
                    price: obj['price'],
                    quantity: obj['quantity'],
                    maxQuantity: obj['maxQuantity'],
                    inventoryLocationId: obj['inventoryLocationId']
                });
            }
        }
        cookies.set('added_products_bundles', updatedProducts);
        setCartProducts(cartProductsCopy);
        props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
    }
};
const _renderCartLines = (
    cartLines: CartLine[],
    props: IBuyboxProps<IBuyboxData & IBuyboxViewData>,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    bundlesSummaryScrollPos: number,
    setBundlesSummaryScrollPos: React.Dispatch<React.SetStateAction<number>>,
    bundlesModalSummaryScrollPos: number,
    setBundlesModalSummaryScrollPos: React.Dispatch<React.SetStateAction<number>>,
    isSummaryInModal: boolean
) => {
    let totalPrice = 0.0;
    const cookies = props.context.actionContext.requestContext.cookies;
    let productsAddedInBundles = cookies.get('added_products_bundles')?.value || [];
    const elemId = isSummaryInModal ? 'product_bundles_summary_modal' : 'product_bundles_summary';
    const elem = MsDyn365.isBrowser && window && window.document.getElementById(elemId);
    const rowHeight = 116;
    const minProductsToScroll =
        isSummaryInModal ||
        (MsDyn365.isBrowser && window && window.innerWidth >= 1280 && MsDyn365.isBrowser && window && window.innerWidth <= 1476)
            ? 2
            : 3;
    const upArrowId = isSummaryInModal ? 'up-arrow-btn-modal' : 'up-arrow-btn';
    const downArrowId = isSummaryInModal ? 'down-arrow-btn-modal' : 'down-arrow-btn';
    let scrollPos = isSummaryInModal ? bundlesModalSummaryScrollPos : bundlesSummaryScrollPos;
    const rowHeightForCalc = 90;
    const maxQuantityReachedMsg = props.config.maxQuantityReachedInBundlesmsg
        ? props.config.maxQuantityReachedInBundlesmsg
        : `There is only 1 product left. Please choose quantity within the available range`;
    if (isSummaryInModal) {
        cartProducts = cartProducts.filter(cp =>
            props.data.cart.result?.cart.CartLines?.find(cl => cl.ProductId === cp.RecordId) ? true : false
        );
        if (cartProducts && props.data.cart.result?.cart.CartLines && props.data.cart.result?.cart.CartLines.length) {
            for (const c of props.data.cart.result?.cart.CartLines) {
                for (const cp of cartProducts) {
                    if (c.ProductId === cp.RecordId) {
                        cp.quantity = c.Quantity;
                    }
                }
            }
        }
    } else {
        cartProducts = cartProducts.filter(
            cp => Array.isArray(productsAddedInBundles) && productsAddedInBundles.find(p => p['productId'] === cp.RecordId)
        );
    }
    return (
        <>
            {cartProducts && cartProducts.length > minProductsToScroll ? (
                <Button
                    id={upArrowId}
                    onClick={() => {
                        if (elem) {
                            if (elem.scrollTop - rowHeight > 0) {
                                elem.scrollTop -= rowHeight;
                            } else {
                                elem.scrollTop = 0;
                            }
                            if (isSummaryInModal) {
                                setBundlesModalSummaryScrollPos(elem.scrollTop);
                            } else {
                                setBundlesSummaryScrollPos(elem.scrollTop);
                            }
                        }
                    }}
                    hidden={elem && scrollPos < 50 ? true : false}
                ></Button>
            ) : (
                <></>
            )}
            <div
                id={elemId}
                className='price-summary__product-list'
                onScroll={() => {
                    if (elem && Math.abs(Math.ceil(elem.scrollTop) - Math.ceil(scrollPos)) > rowHeightForCalc) {
                        if (!isSummaryInModal) {
                            if (elem.scrollTop >= (cartProducts.length - (minProductsToScroll + 1)) * rowHeightForCalc) {
                                setBundlesSummaryScrollPos(elem?.scrollTop);
                            } else if (elem.scrollTop < 50) {
                                setBundlesSummaryScrollPos(elem?.scrollTop);
                            }
                        } else {
                            if (elem.scrollTop >= (cartProducts.length - minProductsToScroll + 1) * rowHeightForCalc) {
                                setBundlesModalSummaryScrollPos(elem?.scrollTop);
                            } else if (elem.scrollTop < 50) {
                                setBundlesModalSummaryScrollPos(elem?.scrollTop);
                            }
                            const upArrow = MsDyn365.isBrowser && window && window.document.getElementById(upArrowId);
                            const downArrow = MsDyn365.isBrowser && window && window.document.getElementById(downArrowId);

                            if (elem.scrollTop < 50) {
                                if (upArrow) {
                                    upArrow.hidden = true;
                                }
                            } else {
                                if (upArrow) {
                                    upArrow.hidden = false;
                                }
                            }
                            if (elem.scrollTop > (cartProducts.length - minProductsToScroll) * rowHeightForCalc) {
                                if (downArrow) {
                                    downArrow.hidden = true;
                                }
                            } else {
                                if (downArrow) {
                                    downArrow.hidden = false;
                                }
                            }
                        }
                        scrollPos = elem.scrollTop;
                    }
                }}
            >
                {cartProducts.map(product => {
                    let prodInBundles = undefined;
                    let cookiePrice = undefined;
                    let maxQuantityForBundle = 0;
                    let shouldShowQuantityReachedErrorMsg = false;
                    const fallbackImageUrl =
                        product && getFallbackImageUrl(product.ItemId, props.context.actionContext.requestContext.apiSettings);
                    const cl = props.data.cart?.result?.cart.CartLines?.find(c => c.ProductId === product.RecordId);
                    if (Array.isArray(productsAddedInBundles)) {
                        prodInBundles = productsAddedInBundles.find(p => p['productId'] === product.RecordId);
                        if (prodInBundles) {
                            cookiePrice = prodInBundles['price'];
                            maxQuantityForBundle = prodInBundles['maxQuantity'];
                            if (!isSummaryInModal) {
                                product.quantity = prodInBundles['quantity'];
                                if (cl && cl.Quantity && product.quantity && maxQuantityForBundle) {
                                    shouldShowQuantityReachedErrorMsg = product.quantity + cl.Quantity > maxQuantityForBundle;
                                }
                            }
                        }
                    }
                    if (maxQuantityForBundle <= 0) {
                        const cookies = props.context.actionContext.requestContext.cookies;
                        const maxQuantities = cookies.get('product_bundles_maximum_available_quantities')?.value || [];
                        if (Array.isArray(maxQuantities)) {
                            for (const maxQ of maxQuantities) {
                                if (maxQ.productId === product.RecordId) {
                                    maxQuantityForBundle = maxQ.maxQuantity;
                                    break;
                                }
                            }
                        }
                    }
                    if (product.quantity && product.quantity >= maxQuantityForBundle) {
                        shouldShowQuantityReachedErrorMsg = true;
                    }
                    const priceObj: ProductPrice = {
                        BasePrice: product.BasePrice,
                        AdjustedPrice: cookiePrice ? cookiePrice : product.Price,
                        CustomerContextualPrice: cookiePrice ? cookiePrice : product.Price
                    };
                    totalPrice =
                        totalPrice + (cookiePrice ? Number(cookiePrice) : product.Price) * (product.quantity ? product.quantity : 0);
                    const imageSettings = {
                        viewports: {
                            xs: { q: 'w=80&h=94&m=6', w: 0, h: 0 },
                            sm: { q: 'w=148&h=174&m=6', w: 0, h: 0 },
                            lg: { q: 'w=148&h=174&m=6', w: 0, h: 0 }
                        },
                        lazyload: true
                    };
                    const baseImageUrl: string = props.context.request.apiSettings.baseImageUrl;
                    <div></div>;
                    return (
                        <>
                            <div className='position-relative price-summary__product'>
                                <div className='price-summary__content'>
                                    <div className='msc-cart-line__product-image'>
                                        <Msdyn365.Image
                                            src={`${baseImageUrl}${product.PrimaryImageUrl}` || ''}
                                            fallBackSrc={fallbackImageUrl}
                                            altText={product.Name}
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={imageSettings}
                                            loadFailureBehavior='empty'
                                        />
                                    </div>
                                    <div>
                                        <p className='product-name' title={product && product.Name}>
                                            {product && product.Name}
                                        </p>
                                        <PriceComponent
                                            context={props.context}
                                            id={'dobbies-product-collection'}
                                            typeName={'dobbies-product-collection'}
                                            data={{ price: priceObj }}
                                            savingsText={undefined}
                                            freePriceText={'Free'}
                                            originalPriceText={'Original price'}
                                            discountLine={undefined}
                                            cartData={props.data.cart.result?.cart}
                                            updatedPrice={cookiePrice ? cookiePrice : product.Price}
                                            getTierId={undefined}
                                            clubPlusDiscountsOfferId={undefined}
                                        />
                                        {/* <p className='product-quantity'>Quantity: {product.quantity}</p> */}
                                        <p className='product-quantity'>Quantity: </p>
                                        <Quantity
                                            id={`msc-cart-line__quantity_${product.RecordId}`}
                                            currentCount={product.quantity}
                                            onChange={(newVal: number) => {
                                                onQuantityChange(
                                                    props,
                                                    product.RecordId,
                                                    newVal,
                                                    cartProducts,
                                                    setCartProducts,
                                                    isSummaryInModal,
                                                    maxQuantityForBundle
                                                );
                                            }}
                                            hideQuantityControls={false}
                                            disabledInput={false}
                                            max={maxQuantityForBundle}
                                            min={1}
                                        />
                                        {shouldShowQuantityReachedErrorMsg && <p className='quantity-error-msg'>{maxQuantityReachedMsg}</p>}
                                    </div>
                                </div>
                                <Button
                                    className='product-remove'
                                    onClick={() => {
                                        if (!isSummaryInModal) {
                                            const cookies = props.context.actionContext.requestContext.cookies;
                                            let productsAddedInBundles = cookies.get('added_products_bundles')?.value || [];
                                            if (Array.isArray(productsAddedInBundles)) {
                                                for (let i = 0; i < productsAddedInBundles.length; i++) {
                                                    if (productsAddedInBundles[i]['productId'] === product.RecordId) {
                                                        delete productsAddedInBundles[i];
                                                    }
                                                }
                                                const updatedProductsAddedInBundles: IDobbiesAddedProductToBundle[] = [];
                                                productsAddedInBundles.map(prod => {
                                                    if (prod && prod['productId']) {
                                                        const dobbiesProductData: IDobbiesAddedProductToBundle = {};
                                                        dobbiesProductData.productId = prod['productId'];
                                                        dobbiesProductData.quantity = prod['quantity'];
                                                        dobbiesProductData.price = prod['price'];
                                                        dobbiesProductData.maxQuantity = prod['maxQuantity'];
                                                        updatedProductsAddedInBundles.push(dobbiesProductData);
                                                    }
                                                });
                                                cookies.set('added_products_bundles', updatedProductsAddedInBundles);
                                                props.context.actionContext.update(new CartModulesStateShareInput(), {
                                                    isCartUpdated: true
                                                });
                                            }
                                            return;
                                        }
                                        const cartlineToRemove = props.data.cart.result?.cart.CartLines?.find(
                                            cl => cl.ProductId === product.RecordId
                                        );
                                        if (cartlineToRemove) {
                                            const input = {
                                                cartLineIds: [cartlineToRemove.LineId!.toString()]
                                            };
                                            props.data.cart.result
                                                ?.removeCartLines(input)
                                                .then(() => {
                                                    props.context.actionContext.update(new CartModulesStateShareInput(), {
                                                        isCartUpdated: true
                                                    });
                                                })
                                                .catch(error => {
                                                    props.telemetry.warning(error);
                                                    props.telemetry.debug('Unable to Remove Cart Line');
                                                });
                                        } else {
                                            props.context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                        }
                                    }}
                                ></Button>
                            </div>
                        </>
                    );
                })}
            </div>

            {cartProducts && cartProducts.length > minProductsToScroll ? (
                <Button
                    id={downArrowId}
                    onClick={() => {
                        if (elem) {
                            elem.scrollTop += rowHeight;
                            if (isSummaryInModal) {
                                setBundlesModalSummaryScrollPos(elem.scrollTop);
                            } else {
                                setBundlesSummaryScrollPos(elem.scrollTop);
                            }
                        }
                    }}
                    hidden={elem && scrollPos > (cartProducts.length - minProductsToScroll) * rowHeightForCalc ? true : false}
                ></Button>
            ) : (
                <></>
            )}
            <p className='price-summary__total-price'>
                {props.config.totalPriceText ? props.config.totalPriceText : 'Total price:'}
                <span>
                    {' '}
                    {new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currencyDisplay: 'symbol',
                        currency: 'GBP',
                        minimumFractionDigits: 2
                    }).format(totalPrice)}
                </span>
            </p>
        </>
    );
};
// Function for product schema
// const _renderSchema = (
//     product: SimpleProduct | undefined,
//     allAttributes: AttributeValue[] | undefined,
//     pageUrl: string,
//     imageUrl: string,
//     ratingsSummary: RatingsSummary | undefined,
//     productPrice: ProductPrice | undefined
// ) => {
//     const productBrand = getProductBrand(allAttributes);
//     const ratingObj = ratingsSummary && calculateBestAndWorstRating(ratingsSummary);
//     const productPriceObj = productPrice && getProductPrice(productPrice);
//     const ratingCount = ratingsSummary && ratingsSummary.totalRatingsCount;

//     {
//         /** Node added for schema */
//     }
//     return (
//         <Node className='' vocab='https://schema.org/' typeof='product'>
//             <meta property='name' content={product?.Name} />
//             <meta property='description' content={product?.Description} />
//             <meta property='brand' content={productBrand} />
//             <meta property='image' content={`${imageUrl}${product?.PrimaryImageUrl}`} />
//             <Node tag='span' className='' property='offers' typeof='AggregateOffer'>
//                 <meta property='url' content={pageUrl} />
//                 <meta property='priceCurrency' content='GBP' />
//                 <meta property='lowPrice' content={productPriceObj?.lowPrice.toString()} />
//                 <meta property='highPrice' content={productPriceObj?.highPrice.toString()} />
//             </Node>
//             {ratingCount && ratingCount > 0 ? (
//                 <Node tag='span' className='' property='aggregateRating' typeof='AggregateRating'>
//                     <meta property='ratingValue' content={ratingsSummary?.averageRating?.toString()} />
//                     <meta property='ratingCount' content={ratingCount?.toString()} />
//                     <meta property='bestRating' content={ratingObj?.bestRating.toString()} />
//                     <meta property='worstRating' content={ratingObj?.worstRating.toString()} />
//                 </Node>
//             ) : (
//                 undefined
//             )}
//         </Node>
//     );
// };

/* VSI Customization - START - 27/10/20 */

// const getProductBrand = (allAttributes: AttributeValue[] | undefined) => {
//     const brandAttribute = allAttributes && allAttributes.find(x => x.Name === 'Brand');
//     return (brandAttribute && brandAttribute.TextValue) || 'Dobbies';
// };

// const getProductPrice = (price: ProductPrice | undefined) => {
//     let lowPrice = 0;
//     let highPrice = 0;
//     if (price) {
//         if (price?.AdjustedPrice !== price?.CustomerContextualPrice) {
//             lowPrice = price?.CustomerContextualPrice !== undefined ? price?.CustomerContextualPrice : lowPrice;
//             highPrice = price?.AdjustedPrice !== undefined ? price?.AdjustedPrice : highPrice;
//         } else if (price?.AdjustedPrice === price?.CustomerContextualPrice) {
//             lowPrice = highPrice = price?.AdjustedPrice !== undefined ? price?.AdjustedPrice : lowPrice;
//         }
//     }
//     return { lowPrice, highPrice };
// };

// const calculateBestAndWorstRating = (ratingValue: RatingsSummary | undefined) => {
//     let bestRating = 0;
//     let worstRating = 0;
//     if (ratingValue) {
//         if (ratingValue && ratingValue?.totalRatingsCount !== 0) {
//             if (ratingValue.star5Count !== 0) {
//                 bestRating = 5;
//                 worstRating = 5;
//             }
//             if (ratingValue.star4Count !== 0) {
//                 if (bestRating === 0) {
//                     bestRating = 4;
//                 }
//                 worstRating = 4;
//             }
//             if (ratingValue.star3Count !== 0) {
//                 if (bestRating === 0) {
//                     bestRating = 3;
//                 }
//                 worstRating = 3;
//             }
//             if (ratingValue.star2Count !== 0) {
//                 if (bestRating === 0) {
//                     bestRating = 2;
//                 }
//                 worstRating = 2;
//             }
//             if (ratingValue.star1Count !== 0) {
//                 if (bestRating === 0) {
//                     bestRating = 1;
//                 }
//                 worstRating = 1;
//             }
//         }
//     }
//     return { bestRating, worstRating };
// };
/* Following function returns attributes of current product */
const _getCustomAttribute = async (
    _allAttributes: AttributeValue[],
    selectedAttributes: string[] | undefined,
    stateAttributes: AttributeValue[],
    setAttributes: React.Dispatch<React.SetStateAction<{}[]>>,
    SetIsAgeRestricted: React.Dispatch<React.SetStateAction<boolean>>,
    SetIsVendorShipped: React.Dispatch<React.SetStateAction<boolean>>
) => {
    if (stateAttributes && stateAttributes.length && stateAttributes.length > 0) {
        // State is already set
        return;
    }
    if (!selectedAttributes || (selectedAttributes && selectedAttributes.length === 0)) {
        return;
    }
    const allAttributes = _allAttributes;
    const customAttributes: AttributeValue[] = [];

    selectedAttributes &&
        selectedAttributes.map(selectedAttribute => {
            const selectedAttributeName = selectedAttribute.trim().toLowerCase();
            // Check if it is found in action response, add it in attribute array
            const matchingAttribute = allAttributes.find(attribute => {
                return selectedAttributeName === attribute.Name?.toLowerCase();
            });
            matchingAttribute && customAttributes.push(matchingAttribute);
        });

    setAttributes(customAttributes);

    const ageRestrictedAttribute =
        allAttributes &&
        allAttributes.find(customAttribute => {
            const attributeName = customAttribute.Name && customAttribute.Name.trim().toLowerCase();
            return attributeName === 'agerestriction' || attributeName === 'age restriction';
        });
    // check if product has age restriction
    ageRestrictedAttribute &&
        ageRestrictedAttribute.TextValue &&
        ageRestrictedAttribute.TextValue.trim().toLowerCase() === 'true' &&
        SetIsAgeRestricted(true);
    // check if product is vendorshipped
    const isvendorShippedAttribute =
        allAttributes &&
        allAttributes.find(attribute => {
            const attributeName = attribute.Name && attribute.Name.trim().toLowerCase();
            return attributeName === 'isvendershipproduct';
        });
    const isVendorShipTextValue =
        isvendorShippedAttribute && isvendorShippedAttribute.TextValue && isvendorShippedAttribute.TextValue.trim().toLowerCase();
    const isVendorShiped = isVendorShipTextValue && (isVendorShipTextValue === 'yes' || isVendorShipTextValue === 'true');
    !!isVendorShiped === false && SetIsVendorShipped(false);
};

// Following function renders 'Add to bag' notification'
const _renderAddedToCartNotification = (resources: IBuyboxResources, navigationUrl: string | undefined): JSX.Element => {
    const { buyBoxHeaderMessageText, buyBoxGoToCartText } = resources;
    const gotoCartLinkData: Msdyn365.ILinksData = {
        ariaLabel: buyBoxGoToCartText,
        linkText: buyBoxGoToCartText,
        linkUrl: navigationUrl,
        role: 'button'
    };
    return (
        <Node className='msc-added-to-cart-notification'>
            <Node className='msc-add-to-cart-notification__title'>{buyBoxHeaderMessageText}</Node>
            <Node className='msc-add-to-cart-notification__button'>
                <Msdyn365.Link link={gotoCartLinkData} />
            </Node>
        </Node>
    );
};

// Following function renders reviews count
const _renderReviewCount = (reviewsCount: number | undefined, resources: IBuyboxResources): JSX.Element => {
    const { reviewCountLabelForOne, reviewCountLabelForMore } = resources;
    let _reviewsCount = reviewsCount;
    // display 0 if there is no reviews
    _reviewsCount = reviewsCount ? reviewsCount : 0;
    return (
        <Node tag='div' className='ms-buybox__reviews-count-section'>
            <Node tag='span' className='reviews-count'>
                {_reviewsCount}
            </Node>
            <Node tag='span' className='reviews-count-label'>
                {reviewsCount === 1 ? reviewCountLabelForOne : reviewCountLabelForMore}
            </Node>
        </Node>
    );
};

// Following function is used to render text block for showing banner
const _renderTextBlock = (textBlocks: React.ReactNode[]): JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }
    return <>{textBlocks[0]}</>;
};

// Following function renders quantity with plus and minus buttons
const _renderQuantity = (
    quantityComponent: IBuyboxProductQuantityViewProps,
    callbacks: IBuyboxCallbacks,
    props: IBuyboxProps<IBuyboxData>,
    state: IBuyboxState,
    extentionResources: IBuyboxResources,
    isCNCTileSelected: boolean,
    selectedCNCOrgUnitLoc?: IFullOrgUnitAvailability,
    productAvailabilitesForCNC?: IProductInventoryInformation[]
): JSX.Element => {
    const { ContainerProps } = quantityComponent;

    const {
        resources,
        context: {
            app: {
                config: { maxQuantityForCartLineItem }
            }
        },
        data: {
            product: { result: productData }
        }
    } = props;
    const { quantity } = state;

    const onChange = (newValue: number) => {
        if (callbacks.updateQuantity) {
            callbacks.updateQuantity(newValue);
        }
    };

    const cncInventory =
        productAvailabilitesForCNC &&
        productAvailabilitesForCNC?.find(
            inventory => inventory.InventLocationId === selectedCNCOrgUnitLoc?.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId
        );
    let productInventory = props.data.productAvailableQuantity.result?.find(
        inventory => inventory.ProductAvailableQuantity.ProductId === productData?.RecordId
    );
    if (isCNCTileSelected && cncInventory) {
        productInventory = cncInventory;
    }
    let maxQuantity = maxQuantityForCartLineItem || 10;
    if (
        productInventory?.ProductAvailableQuantity.AvailableQuantity &&
        productInventory?.ProductAvailableQuantity.AvailableQuantity < maxQuantity
    ) {
        maxQuantity = productInventory?.ProductAvailableQuantity.AvailableQuantity;
    }
    /* VSI Customization - Removed errors from here and displayed it in _renderAddToCart() function only */
    return (
        <Node {...ContainerProps}>
            <Quantity
                id='ms-buybox__product-quantity-input'
                max={maxQuantity || 10}
                currentCount={quantity}
                onChange={onChange}
                inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
            />
        </Node>
    );
};
/* VSI Customization - END - 10/11/20 */

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { button, ContainerProps } = addToCart;

    return <Node {...ContainerProps}>{button}</Node>;
};

const _renderAddToWishlist = (addToWishlist: IBuyboxAddToWishlistViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToWishlist;

    return (
        <Node {...ContainerProps}>
            <div>{errorBlock}</div>
            {React.cloneElement(button as React.ReactElement, {
                showInlineLabel: true,
                addedLabelText: 'Added to wishlist',
                redirectOnAddedClick: true,
                wishlistRedirectUrl: '/wishlist'
            })}
        </Node>
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;

    return <Node {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }

    return <>{socialShare[0]}</>;
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, errors, modal } = findInStore;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {/* {heading} */}
            {/* {description} */}
            {errors}
            {modal}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};
export default BuyboxView;
